import * as read_api from "./alan_api";
function serialize_client_id_path($_client_id_path: read_api.Cclient_id_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_client_id_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__client_id_path = $_client_id_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__client_id_path = $_client_id_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_client_id_path($_yes__has_steps__client_id_path.properties.tail);
				{
					let raw_type: Record<string, any>;
					switch ($_yes__has_steps__client_id_path.properties.type.state.name) {
						case 'collection entry': {
							const $_collection_entry__type__yes__has_steps__client_id_path = $_yes__has_steps__client_id_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["collection"] = $_collection_entry__type__yes__has_steps__client_id_path.properties.collection.entry;
							raw_data["entry"] = $_collection_entry__type__yes__has_steps__client_id_path.properties.entry.entry;
							raw_type = raw_data
							break;
						}
						case 'group': {
							const $_group__type__yes__has_steps__client_id_path = $_yes__has_steps__client_id_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["group"] = $_group__type__yes__has_steps__client_id_path.properties.group.entry;
							raw_type = raw_data
							break;
						}
						case 'operation': {
							const $_operation__type__yes = $_yes__has_steps__client_id_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["operation"] = $_operation__type__yes.properties.operation.entry;
							raw_type = raw_data
							break;
						}
						case 'state': {
							const $_state__type__yes__has_steps__client_id_path = $_yes__has_steps__client_id_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["state"] = $_state__type__yes__has_steps__client_id_path.properties.state.entry;
							raw_data["state group"] = $_state__type__yes__has_steps__client_id_path.properties.state_group.entry;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_steps__client_id_path.properties.type.state)
					}
					raw_data["type"] = [$_yes__has_steps__client_id_path.properties.type.state.name, raw_type];
				}
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_id_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_client_id_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_id_path($_id_path: read_api.Cid_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_id_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__id_path = $_id_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__id_path = $_id_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_id_path($_yes__has_steps__id_path.properties.tail);
				{
					let raw_type: Record<string, any>;
					switch ($_yes__has_steps__id_path.properties.type.state.name) {
						case 'collection entry': {
							const $_collection_entry__type__yes__has_steps__id_path = $_yes__has_steps__id_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["collection"] = $_collection_entry__type__yes__has_steps__id_path.properties.collection.entry;
							raw_data["id"] = $_collection_entry__type__yes__has_steps__id_path.properties.id;
							raw_type = raw_data
							break;
						}
						case 'group': {
							const $_group__type__yes__has_steps__id_path = $_yes__has_steps__id_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["group"] = $_group__type__yes__has_steps__id_path.properties.group.entry;
							raw_type = raw_data
							break;
						}
						case 'state': {
							const $_state__type__yes__has_steps__id_path = $_yes__has_steps__id_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["state"] = $_state__type__yes__has_steps__id_path.properties.state.entry;
							raw_data["state group"] = $_state__type__yes__has_steps__id_path.properties.state_group.entry;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_steps__id_path.properties.type.state)
					}
					raw_data["type"] = [$_yes__has_steps__id_path.properties.type.state.name, raw_type];
				}
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_id_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_id_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_node($_node: read_api.Cnode) {
	const raw_data: Record<string, any> = {};
	const raw_attributes: Record<string, any> = {};
	for (let [k,v] of $_node.properties.attributes) {
		const $_attributes = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_type: Record<string, any>;
			switch ($_attributes.properties.type.state.name) {
				case 'operation': {
					const $_operation__type__attributes = $_attributes.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_started: Record<string, any>;
						switch ($_operation__type__attributes.properties.started.state.name) {
							case 'no': {
								const $_no__started = $_operation__type__attributes.properties.started.state.node;
								const raw_data: Record<string, any> = {};
								raw_started = raw_data
								break;
							}
							case 'yes': {
								const $_yes__started = $_operation__type__attributes.properties.started.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_executable: Record<string, any>;
									switch ($_yes__started.properties.executable.state.name) {
										case 'no': {
											const $_no__executable = $_yes__started.properties.executable.state.node;
											const raw_data: Record<string, any> = {};
											raw_executable = raw_data
											break;
										}
										case 'yes': {
											const $_yes__executable = $_yes__started.properties.executable.state.node;
											const raw_data: Record<string, any> = {};
											raw_executable = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__started.properties.executable.state)
									}
									raw_data["executable"] = [$_yes__started.properties.executable.state.name, raw_executable];
								}
								{
									let raw_executing: Record<string, any>;
									switch ($_yes__started.properties.executing.state.name) {
										case 'no': {
											const $_no__executing = $_yes__started.properties.executing.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_last_result: Record<string, any>;
												switch ($_no__executing.properties.last_result.state.name) {
													case 'failure': {
														const $_failure__last_result = $_no__executing.properties.last_result.state.node;
														const raw_data: Record<string, any> = {};
														raw_last_result = raw_data
														break;
													}
													case 'not invoked': {
														const $_not_invoked = $_no__executing.properties.last_result.state.node;
														const raw_data: Record<string, any> = {};
														raw_last_result = raw_data
														break;
													}
													case 'success': {
														const $_success__last_result = $_no__executing.properties.last_result.state.node;
														const raw_data: Record<string, any> = {};
														raw_last_result = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__executing.properties.last_result.state)
												}
												raw_data["last result"] = [$_no__executing.properties.last_result.state.name, raw_last_result];
											}
											raw_executing = raw_data
											break;
										}
										case 'yes': {
											const $_yes__executing = $_yes__started.properties.executing.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_can_continue: Record<string, any>;
												switch ($_yes__executing.properties.can_continue.state.name) {
													case 'no': {
														const $_no__can_continue = $_yes__executing.properties.can_continue.state.node;
														const raw_data: Record<string, any> = {};
														raw_can_continue = raw_data
														break;
													}
													case 'yes': {
														const $_yes__can_continue = $_yes__executing.properties.can_continue.state.node;
														const raw_data: Record<string, any> = {};
														raw_can_continue = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__executing.properties.can_continue.state)
												}
												raw_data["can continue"] = [$_yes__executing.properties.can_continue.state.name, raw_can_continue];
											}
											raw_executing = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__started.properties.executing.state)
									}
									raw_data["executing"] = [$_yes__started.properties.executing.state.name, raw_executing];
								}
								{
									let raw_is_valid: Record<string, any>;
									switch ($_yes__started.properties.is_valid.state.name) {
										case 'no': {
											const $_no__is_valid__yes = $_yes__started.properties.is_valid.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_valid = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_valid__yes = $_yes__started.properties.is_valid.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_valid = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__started.properties.is_valid.state)
									}
									raw_data["is valid"] = [$_yes__started.properties.is_valid.state.name, raw_is_valid];
								}
								raw_data["node"] = serialize_node($_yes__started.properties.node);
								raw_started = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_operation__type__attributes.properties.started.state)
						}
						raw_data["started"] = [$_operation__type__attributes.properties.started.state.name, raw_started];
					}
					{
						let raw_type: Record<string, any>;
						switch ($_operation__type__attributes.properties.type.state.name) {
							case 'action': {
								const $_action = $_operation__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_type = raw_data
								break;
							}
							case 'command': {
								const $_command = $_operation__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_execute_permitted: Record<string, any>;
									switch ($_command.properties.execute_permitted.state.name) {
										case 'no': {
											const $_no__execute_permitted = $_command.properties.execute_permitted.state.node;
											const raw_data: Record<string, any> = {};
											raw_execute_permitted = raw_data
											break;
										}
										case 'yes': {
											const $_yes__execute_permitted = $_command.properties.execute_permitted.state.node;
											const raw_data: Record<string, any> = {};
											raw_execute_permitted = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_command.properties.execute_permitted.state)
									}
									raw_data["execute permitted"] = [$_command.properties.execute_permitted.state.name, raw_execute_permitted];
								}
								raw_type = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_operation__type__attributes.properties.type.state)
						}
						raw_data["type"] = [$_operation__type__attributes.properties.type.state.name, raw_type];
					}
					raw_type = raw_data
					break;
				}
				case 'property': {
					const $_property = $_attributes.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_type: Record<string, any>;
						switch ($_property.properties.type.state.name) {
							case 'collection': {
								const $_collection = $_property.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["amount of entries"] = $_collection.properties.amount_of_entries.value;
								{
									let raw_can_create_entry: Record<string, any>;
									switch ($_collection.properties.can_create_entry.state.name) {
										case 'no': {
											const $_no__can_create_entry__collection = $_collection.properties.can_create_entry.state.node;
											const raw_data: Record<string, any> = {};
											raw_can_create_entry = raw_data
											break;
										}
										case 'yes': {
											const $_yes__can_create_entry__collection = $_collection.properties.can_create_entry.state.node;
											const raw_data: Record<string, any> = {};
											raw_can_create_entry = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_collection.properties.can_create_entry.state)
									}
									raw_data["can create entry"] = [$_collection.properties.can_create_entry.state.name, raw_can_create_entry];
								}
								{
									let raw_can_download_files: Record<string, any>;
									switch ($_collection.properties.can_download_files.state.name) {
										case 'no': {
											const $_no__can_download_files__collection = $_collection.properties.can_download_files.state.node;
											const raw_data: Record<string, any> = {};
											raw_can_download_files = raw_data
											break;
										}
										case 'yes': {
											const $_yes__can_download_files__collection = $_collection.properties.can_download_files.state.node;
											const raw_data: Record<string, any> = {};
											raw_can_download_files = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_collection.properties.can_download_files.state)
									}
									raw_data["can download files"] = [$_collection.properties.can_download_files.state.name, raw_can_download_files];
								}
								const raw_entries: Record<string, any> = {};
								for (let [k,v] of $_collection.properties.entries) {
									const $_entries__collection = v;
									const raw_data: Record<string, any> = {};
									raw_data["key"] = $_entries__collection.properties.key.entry;
									{
										let raw_location: Record<string, any>;
										switch ($_entries__collection.properties.location.state.name) {
											case 'local': {
												const $_local__location__entries = $_entries__collection.properties.location.state.node;
												const raw_data: Record<string, any> = {};
												{
													let raw_modified_by: Record<string, any>;
													switch ($_local__location__entries.properties.modified_by.state.name) {
														case 'engine': {
															const $_engine__modified_by = $_local__location__entries.properties.modified_by.state.node;
															const raw_data: Record<string, any> = {};
															raw_modified_by = raw_data
															break;
														}
														case 'user': {
															const $_user__modified_by = $_local__location__entries.properties.modified_by.state.node;
															const raw_data: Record<string, any> = {};
															raw_modified_by = raw_data
															break;
														}
														default:
															throw new Error("unexpected state: " + $_local__location__entries.properties.modified_by.state)
													}
													raw_data["modified by"] = [$_local__location__entries.properties.modified_by.state.name, raw_modified_by];
												}
												raw_location = raw_data
												break;
											}
											case 'remote': {
												const $_remote__location__entries = $_entries__collection.properties.location.state.node;
												const raw_data: Record<string, any> = {};
												{
													let raw_marked_for_deletion: Record<string, any>;
													switch ($_remote__location__entries.properties.marked_for_deletion.state.name) {
														case 'no': {
															const $_no__marked_for_deletion = $_remote__location__entries.properties.marked_for_deletion.state.node;
															const raw_data: Record<string, any> = {};
															raw_marked_for_deletion = raw_data
															break;
														}
														case 'yes': {
															const $_yes__marked_for_deletion = $_remote__location__entries.properties.marked_for_deletion.state.node;
															const raw_data: Record<string, any> = {};
															raw_marked_for_deletion = raw_data
															break;
														}
														default:
															throw new Error("unexpected state: " + $_remote__location__entries.properties.marked_for_deletion.state)
													}
													raw_data["marked for deletion"] = [$_remote__location__entries.properties.marked_for_deletion.state.name, raw_marked_for_deletion];
												}
												raw_location = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_entries__collection.properties.location.state)
										}
										raw_data["location"] = [$_entries__collection.properties.location.state.name, raw_location];
									}
									raw_data["node"] = serialize_node($_entries__collection.properties.node);
									raw_data["style"] = serialize_style($_entries__collection.properties.style);
									raw_entries[k] = raw_data
								}
								raw_data["entries"] = raw_entries;
								{
									let raw_has_ordered_graphs: Record<string, any>;
									switch ($_collection.properties.has_ordered_graphs.state.name) {
										case 'no': {
											const $_no__has_ordered_graphs = $_collection.properties.has_ordered_graphs.state.node;
											const raw_data: Record<string, any> = {};
											raw_has_ordered_graphs = raw_data
											break;
										}
										case 'yes': {
											const $_yes__has_ordered_graphs = $_collection.properties.has_ordered_graphs.state.node;
											const raw_data: Record<string, any> = {};
											const raw_ordered_graphs: Record<string, any> = {};
											for (let [k,v] of $_yes__has_ordered_graphs.properties.ordered_graphs) {
												const $_ordered_graphs = v;
												const raw_data: Record<string, any> = {};
												{
													let raw_is_valid: Record<string, any>;
													switch ($_ordered_graphs.properties.is_valid.state.name) {
														case 'no': {
															const $_no__is_valid__ordered_graphs = $_ordered_graphs.properties.is_valid.state.node;
															const raw_data: Record<string, any> = {};
															raw_is_valid = raw_data
															break;
														}
														case 'yes': {
															const $_yes__is_valid__ordered_graphs = $_ordered_graphs.properties.is_valid.state.node;
															const raw_data: Record<string, any> = {};
															raw_is_valid = raw_data
															break;
														}
														default:
															throw new Error("unexpected state: " + $_ordered_graphs.properties.is_valid.state)
													}
													raw_data["is valid"] = [$_ordered_graphs.properties.is_valid.state.name, raw_is_valid];
												}
												raw_ordered_graphs[k] = raw_data
											}
											raw_data["ordered graphs"] = raw_ordered_graphs;
											raw_has_ordered_graphs = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_collection.properties.has_ordered_graphs.state)
									}
									raw_data["has ordered graphs"] = [$_collection.properties.has_ordered_graphs.state.name, raw_has_ordered_graphs];
								}
								{
									let raw_is_editable: Record<string, any>;
									switch ($_collection.properties.is_editable.state.name) {
										case 'no': {
											const $_no__is_editable__collection = $_collection.properties.is_editable.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_editable = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_editable__collection = $_collection.properties.is_editable.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_edit_mode: Record<string, any>;
												switch ($_yes__is_editable__collection.properties.edit_mode.state.name) {
													case 'off': {
														const $_off__edit_mode__yes__is_editable__collection = $_yes__is_editable__collection.properties.edit_mode.state.node;
														const raw_data: Record<string, any> = {};
														raw_edit_mode = raw_data
														break;
													}
													case 'on': {
														const $_on__edit_mode__yes__is_editable__collection = $_yes__is_editable__collection.properties.edit_mode.state.node;
														const raw_data: Record<string, any> = {};
														raw_edit_mode = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__is_editable__collection.properties.edit_mode.state)
												}
												raw_data["edit mode"] = [$_yes__is_editable__collection.properties.edit_mode.state.name, raw_edit_mode];
											}
											raw_is_editable = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_collection.properties.is_editable.state)
									}
									raw_data["is editable"] = [$_collection.properties.is_editable.state.name, raw_is_editable];
								}
								{
									let raw_is_empty: Record<string, any>;
									switch ($_collection.properties.is_empty.state.name) {
										case 'no': {
											const $_no__is_empty__collection = $_collection.properties.is_empty.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_size: Record<string, any>;
												switch ($_no__is_empty__collection.properties.size.state.name) {
													case 'multiple': {
														const $_multiple__size__no__is_empty__collection = $_no__is_empty__collection.properties.size.state.node;
														const raw_data: Record<string, any> = {};
														raw_size = raw_data
														break;
													}
													case 'single': {
														const $_single__size__no__is_empty__collection = $_no__is_empty__collection.properties.size.state.node;
														const raw_data: Record<string, any> = {};
														raw_size = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_empty__collection.properties.size.state)
												}
												raw_data["size"] = [$_no__is_empty__collection.properties.size.state.name, raw_size];
											}
											raw_is_empty = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_empty__collection = $_collection.properties.is_empty.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_empty = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_collection.properties.is_empty.state)
									}
									raw_data["is empty"] = [$_collection.properties.is_empty.state.name, raw_is_empty];
								}
								{
									let raw_is_valid: Record<string, any>;
									switch ($_collection.properties.is_valid.state.name) {
										case 'no': {
											const $_no__is_valid__collection = $_collection.properties.is_valid.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_cardinality_constraint_violation: Record<string, any>;
												switch ($_no__is_valid__collection.properties.cardinality_constraint_violation.state.name) {
													case 'no': {
														const $_no__cardinality_constraint_violation = $_no__is_valid__collection.properties.cardinality_constraint_violation.state.node;
														const raw_data: Record<string, any> = {};
														raw_cardinality_constraint_violation = raw_data
														break;
													}
													case 'yes': {
														const $_yes__cardinality_constraint_violation = $_no__is_valid__collection.properties.cardinality_constraint_violation.state.node;
														const raw_data: Record<string, any> = {};
														raw_cardinality_constraint_violation = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__collection.properties.cardinality_constraint_violation.state)
												}
												raw_data["cardinality constraint violation"] = [$_no__is_valid__collection.properties.cardinality_constraint_violation.state.name, raw_cardinality_constraint_violation];
											}
											{
												let raw_entries_are_invalid: Record<string, any>;
												switch ($_no__is_valid__collection.properties.entries_are_invalid.state.name) {
													case 'no': {
														const $_no__entries_are_invalid = $_no__is_valid__collection.properties.entries_are_invalid.state.node;
														const raw_data: Record<string, any> = {};
														raw_entries_are_invalid = raw_data
														break;
													}
													case 'yes': {
														const $_yes__entries_are_invalid = $_no__is_valid__collection.properties.entries_are_invalid.state.node;
														const raw_data: Record<string, any> = {};
														raw_entries_are_invalid = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__collection.properties.entries_are_invalid.state)
												}
												raw_data["entries are invalid"] = [$_no__is_valid__collection.properties.entries_are_invalid.state.name, raw_entries_are_invalid];
											}
											raw_is_valid = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_valid__collection = $_collection.properties.is_valid.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_valid = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_collection.properties.is_valid.state)
									}
									raw_data["is valid"] = [$_collection.properties.is_valid.state.name, raw_is_valid];
								}
								{
									let raw_joined: Record<string, any>;
									switch ($_collection.properties.joined.state.name) {
										case 'no': {
											const $_no__joined = $_collection.properties.joined.state.node;
											const raw_data: Record<string, any> = {};
											raw_joined = raw_data
											break;
										}
										case 'yes': {
											const $_yes__joined = $_collection.properties.joined.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["amount of entries"] = $_yes__joined.properties.amount_of_entries.value;
											const raw_entries: Record<string, any> = {};
											for (let [k,v] of $_yes__joined.properties.entries) {
												const $_entries__yes__joined = v;
												const raw_data: Record<string, any> = {};
												{
													let raw_collection_entry: Record<string, any>;
													switch ($_entries__yes__joined.properties.collection_entry.state.name) {
														case 'entry': {
															const $_entry__collection_entry = $_entries__yes__joined.properties.collection_entry.state.node;
															const raw_data: Record<string, any> = {};
															raw_data["entry"] = $_entry__collection_entry.properties.entry.entry;
															raw_collection_entry = raw_data
															break;
														}
														case 'none': {
															const $_none__collection_entry = $_entries__yes__joined.properties.collection_entry.state.node;
															const raw_data: Record<string, any> = {};
															raw_collection_entry = raw_data
															break;
														}
														default:
															throw new Error("unexpected state: " + $_entries__yes__joined.properties.collection_entry.state)
													}
													raw_data["collection entry"] = [$_entries__yes__joined.properties.collection_entry.state.name, raw_collection_entry];
												}
												{
													let raw_referenced_entry: Record<string, any>;
													switch ($_entries__yes__joined.properties.referenced_entry.state.name) {
														case 'entry': {
															const $_entry__referenced_entry = $_entries__yes__joined.properties.referenced_entry.state.node;
															const raw_data: Record<string, any> = {};
															{
																let raw_can_create_entry: Record<string, any>;
																switch ($_entry__referenced_entry.properties.can_create_entry.state.name) {
																	case 'no': {
																		const $_no__can_create_entry__entry = $_entry__referenced_entry.properties.can_create_entry.state.node;
																		const raw_data: Record<string, any> = {};
																		raw_can_create_entry = raw_data
																		break;
																	}
																	case 'yes': {
																		const $_yes__can_create_entry__entry = $_entry__referenced_entry.properties.can_create_entry.state.node;
																		const raw_data: Record<string, any> = {};
																		raw_can_create_entry = raw_data
																		break;
																	}
																	default:
																		throw new Error("unexpected state: " + $_entry__referenced_entry.properties.can_create_entry.state)
																}
																raw_data["can create entry"] = [$_entry__referenced_entry.properties.can_create_entry.state.name, raw_can_create_entry];
															}
															raw_data["entry"] = $_entry__referenced_entry.properties.entry.entry;
															raw_referenced_entry = raw_data
															break;
														}
														case 'none': {
															const $_none__referenced_entry = $_entries__yes__joined.properties.referenced_entry.state.node;
															const raw_data: Record<string, any> = {};
															raw_referenced_entry = raw_data
															break;
														}
														default:
															throw new Error("unexpected state: " + $_entries__yes__joined.properties.referenced_entry.state)
													}
													raw_data["referenced entry"] = [$_entries__yes__joined.properties.referenced_entry.state.name, raw_referenced_entry];
												}
												raw_entries[k] = raw_data
											}
											raw_data["entries"] = raw_entries;
											{
												let raw_is_empty: Record<string, any>;
												switch ($_yes__joined.properties.is_empty.state.name) {
													case 'no': {
														const $_no__is_empty__yes__joined = $_yes__joined.properties.is_empty.state.node;
														const raw_data: Record<string, any> = {};
														{
															let raw_size: Record<string, any>;
															switch ($_no__is_empty__yes__joined.properties.size.state.name) {
																case 'multiple': {
																	const $_multiple__size__no__is_empty__yes = $_no__is_empty__yes__joined.properties.size.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_size = raw_data
																	break;
																}
																case 'single': {
																	const $_single__size__no__is_empty__yes = $_no__is_empty__yes__joined.properties.size.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_size = raw_data
																	break;
																}
																default:
																	throw new Error("unexpected state: " + $_no__is_empty__yes__joined.properties.size.state)
															}
															raw_data["size"] = [$_no__is_empty__yes__joined.properties.size.state.name, raw_size];
														}
														raw_is_empty = raw_data
														break;
													}
													case 'yes': {
														const $_yes__is_empty__yes__joined = $_yes__joined.properties.is_empty.state.node;
														const raw_data: Record<string, any> = {};
														raw_is_empty = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__joined.properties.is_empty.state)
												}
												raw_data["is empty"] = [$_yes__joined.properties.is_empty.state.name, raw_is_empty];
											}
											{
												let raw_joined_collection: Record<string, any>;
												switch ($_yes__joined.properties.joined_collection.state.name) {
													case 'resolved': {
														const $_resolved__joined_collection = $_yes__joined.properties.joined_collection.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["collection"] = $_resolved__joined_collection.properties.collection.entry;
														raw_data["referenced node"] = serialize_client_id_path($_resolved__joined_collection.properties.referenced_node);
														raw_joined_collection = raw_data
														break;
													}
													case 'unresolved': {
														const $_unresolved__joined_collection = $_yes__joined.properties.joined_collection.state.node;
														const raw_data: Record<string, any> = {};
														raw_joined_collection = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__joined.properties.joined_collection.state)
												}
												raw_data["joined collection"] = [$_yes__joined.properties.joined_collection.state.name, raw_joined_collection];
											}
											raw_joined = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_collection.properties.joined.state)
									}
									raw_data["joined"] = [$_collection.properties.joined.state.name, raw_joined];
								}
								{
									let raw_last_created_entry: Record<string, any>;
									switch ($_collection.properties.last_created_entry.state.name) {
										case 'entry': {
											const $_entry__last_created_entry = $_collection.properties.last_created_entry.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["entry"] = $_entry__last_created_entry.properties.entry.entry;
											raw_last_created_entry = raw_data
											break;
										}
										case 'none': {
											const $_none__last_created_entry = $_collection.properties.last_created_entry.state.node;
											const raw_data: Record<string, any> = {};
											raw_last_created_entry = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_collection.properties.last_created_entry.state)
									}
									raw_data["last created entry"] = [$_collection.properties.last_created_entry.state.name, raw_last_created_entry];
								}
								{
									let raw_modified: Record<string, any>;
									switch ($_collection.properties.modified.state.name) {
										case 'no': {
											const $_no__modified__collection = $_collection.properties.modified.state.node;
											const raw_data: Record<string, any> = {};
											raw_modified = raw_data
											break;
										}
										case 'yes': {
											const $_yes__modified__collection = $_collection.properties.modified.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_by: Record<string, any>;
												switch ($_yes__modified__collection.properties.by.state.name) {
													case 'engine': {
														const $_engine__by__yes__modified = $_yes__modified__collection.properties.by.state.node;
														const raw_data: Record<string, any> = {};
														raw_by = raw_data
														break;
													}
													case 'user': {
														const $_user__by__yes__modified = $_yes__modified__collection.properties.by.state.node;
														const raw_data: Record<string, any> = {};
														raw_by = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__modified__collection.properties.by.state)
												}
												raw_data["by"] = [$_yes__modified__collection.properties.by.state.name, raw_by];
											}
											raw_modified = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_collection.properties.modified.state)
									}
									raw_data["modified"] = [$_collection.properties.modified.state.name, raw_modified];
								}
								raw_type = raw_data
								break;
							}
							case 'file': {
								const $_file__type__property = $_property.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_backend_known: Record<string, any>;
									switch ($_file__type__property.properties.backend_known.state.name) {
										case 'no': {
											const $_no__backend_known__file = $_file__type__property.properties.backend_known.state.node;
											const raw_data: Record<string, any> = {};
											raw_backend_known = raw_data
											break;
										}
										case 'yes': {
											const $_yes__backend_known__file = $_file__type__property.properties.backend_known.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_is_readable: Record<string, any>;
												switch ($_yes__backend_known__file.properties.is_readable.state.name) {
													case 'no': {
														const $_no__is_readable__yes__backend_known__file = $_yes__backend_known__file.properties.is_readable.state.node;
														const raw_data: Record<string, any> = {};
														raw_is_readable = raw_data
														break;
													}
													case 'yes': {
														const $_yes__is_readable__yes__backend_known__file = $_yes__backend_known__file.properties.is_readable.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["extension"] = $_yes__is_readable__yes__backend_known__file.properties.extension;
														raw_data["token"] = $_yes__is_readable__yes__backend_known__file.properties.token;
														raw_is_readable = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__backend_known__file.properties.is_readable.state)
												}
												raw_data["is readable"] = [$_yes__backend_known__file.properties.is_readable.state.name, raw_is_readable];
											}
											raw_backend_known = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_file__type__property.properties.backend_known.state)
									}
									raw_data["backend known"] = [$_file__type__property.properties.backend_known.state.name, raw_backend_known];
								}
								{
									let raw_is_editable: Record<string, any>;
									switch ($_file__type__property.properties.is_editable.state.name) {
										case 'no': {
											const $_no__is_editable__file = $_file__type__property.properties.is_editable.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_editable = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_editable__file = $_file__type__property.properties.is_editable.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_edit_mode: Record<string, any>;
												switch ($_yes__is_editable__file.properties.edit_mode.state.name) {
													case 'off': {
														const $_off__edit_mode__yes__is_editable__file = $_yes__is_editable__file.properties.edit_mode.state.node;
														const raw_data: Record<string, any> = {};
														raw_edit_mode = raw_data
														break;
													}
													case 'on': {
														const $_on__edit_mode__yes__is_editable__file = $_yes__is_editable__file.properties.edit_mode.state.node;
														const raw_data: Record<string, any> = {};
														raw_edit_mode = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__is_editable__file.properties.edit_mode.state)
												}
												raw_data["edit mode"] = [$_yes__is_editable__file.properties.edit_mode.state.name, raw_edit_mode];
											}
											{
												let raw_modified: Record<string, any>;
												switch ($_yes__is_editable__file.properties.modified.state.name) {
													case 'no': {
														const $_no__modified__yes__is_editable__file = $_yes__is_editable__file.properties.modified.state.node;
														const raw_data: Record<string, any> = {};
														raw_modified = raw_data
														break;
													}
													case 'yes': {
														const $_yes__modified__yes__is_editable__file = $_yes__is_editable__file.properties.modified.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["extension"] = $_yes__modified__yes__is_editable__file.properties.extension;
														{
															let raw_upload_status: Record<string, any>;
															switch ($_yes__modified__yes__is_editable__file.properties.upload_status.state.name) {
																case 'done': {
																	const $_done = $_yes__modified__yes__is_editable__file.properties.upload_status.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_data["token"] = $_done.properties.token;
																	raw_upload_status = raw_data
																	break;
																}
																case 'not uploaded': {
																	const $_not_uploaded = $_yes__modified__yes__is_editable__file.properties.upload_status.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_upload_status = raw_data
																	break;
																}
																case 'uploading': {
																	const $_uploading = $_yes__modified__yes__is_editable__file.properties.upload_status.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_upload_status = raw_data
																	break;
																}
																default:
																	throw new Error("unexpected state: " + $_yes__modified__yes__is_editable__file.properties.upload_status.state)
															}
															raw_data["upload status"] = [$_yes__modified__yes__is_editable__file.properties.upload_status.state.name, raw_upload_status];
														}
														raw_modified = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__is_editable__file.properties.modified.state)
												}
												raw_data["modified"] = [$_yes__is_editable__file.properties.modified.state.name, raw_modified];
											}
											raw_is_editable = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_file__type__property.properties.is_editable.state)
									}
									raw_data["is editable"] = [$_file__type__property.properties.is_editable.state.name, raw_is_editable];
								}
								{
									let raw_is_set: Record<string, any>;
									switch ($_file__type__property.properties.is_set.state.name) {
										case 'no': {
											const $_no__is_set__file__type__property = $_file__type__property.properties.is_set.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_set = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_set__file__type__property = $_file__type__property.properties.is_set.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["extension"] = $_yes__is_set__file__type__property.properties.extension;
											raw_data["token"] = $_yes__is_set__file__type__property.properties.token;
											raw_is_set = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_file__type__property.properties.is_set.state)
									}
									raw_data["is set"] = [$_file__type__property.properties.is_set.state.name, raw_is_set];
								}
								{
									let raw_is_valid: Record<string, any>;
									switch ($_file__type__property.properties.is_valid.state.name) {
										case 'no': {
											const $_no__is_valid__file = $_file__type__property.properties.is_valid.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_extension_not_valid: Record<string, any>;
												switch ($_no__is_valid__file.properties.extension_not_valid.state.name) {
													case 'no': {
														const $_no__extension_not_valid = $_no__is_valid__file.properties.extension_not_valid.state.node;
														const raw_data: Record<string, any> = {};
														raw_extension_not_valid = raw_data
														break;
													}
													case 'yes': {
														const $_yes__extension_not_valid = $_no__is_valid__file.properties.extension_not_valid.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["pattern"] = $_yes__extension_not_valid.properties.pattern;
														raw_extension_not_valid = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__file.properties.extension_not_valid.state)
												}
												raw_data["extension not valid"] = [$_no__is_valid__file.properties.extension_not_valid.state.name, raw_extension_not_valid];
											}
											{
												let raw_not_set: Record<string, any>;
												switch ($_no__is_valid__file.properties.not_set.state.name) {
													case 'no': {
														const $_no__not_set__no__is_valid__file = $_no__is_valid__file.properties.not_set.state.node;
														const raw_data: Record<string, any> = {};
														raw_not_set = raw_data
														break;
													}
													case 'yes': {
														const $_yes__not_set__no__is_valid__file = $_no__is_valid__file.properties.not_set.state.node;
														const raw_data: Record<string, any> = {};
														raw_not_set = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__file.properties.not_set.state)
												}
												raw_data["not set"] = [$_no__is_valid__file.properties.not_set.state.name, raw_not_set];
											}
											raw_is_valid = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_valid__file = $_file__type__property.properties.is_valid.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_valid = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_file__type__property.properties.is_valid.state)
									}
									raw_data["is valid"] = [$_file__type__property.properties.is_valid.state.name, raw_is_valid];
								}
								raw_type = raw_data
								break;
							}
							case 'group': {
								const $_group__type__property = $_property.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["node"] = serialize_node($_group__type__property.properties.node);
								raw_type = raw_data
								break;
							}
							case 'number': {
								const $_number__type__property = $_property.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_backend_known: Record<string, any>;
									switch ($_number__type__property.properties.backend_known.state.name) {
										case 'no': {
											const $_no__backend_known__number = $_number__type__property.properties.backend_known.state.node;
											const raw_data: Record<string, any> = {};
											raw_backend_known = raw_data
											break;
										}
										case 'yes': {
											const $_yes__backend_known__number = $_number__type__property.properties.backend_known.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_is_readable: Record<string, any>;
												switch ($_yes__backend_known__number.properties.is_readable.state.name) {
													case 'no': {
														const $_no__is_readable__yes__backend_known__number = $_yes__backend_known__number.properties.is_readable.state.node;
														const raw_data: Record<string, any> = {};
														raw_is_readable = raw_data
														break;
													}
													case 'yes': {
														const $_yes__is_readable__yes__backend_known__number = $_yes__backend_known__number.properties.is_readable.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["number"] = $_yes__is_readable__yes__backend_known__number.properties.number.value;
														raw_is_readable = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__backend_known__number.properties.is_readable.state)
												}
												raw_data["is readable"] = [$_yes__backend_known__number.properties.is_readable.state.name, raw_is_readable];
											}
											raw_backend_known = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_number__type__property.properties.backend_known.state)
									}
									raw_data["backend known"] = [$_number__type__property.properties.backend_known.state.name, raw_backend_known];
								}
								{
									let raw_is_editable: Record<string, any>;
									switch ($_number__type__property.properties.is_editable.state.name) {
										case 'no': {
											const $_no__is_editable__number = $_number__type__property.properties.is_editable.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_editable = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_editable__number = $_number__type__property.properties.is_editable.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_edit_mode: Record<string, any>;
												switch ($_yes__is_editable__number.properties.edit_mode.state.name) {
													case 'off': {
														const $_off__edit_mode__yes__is_editable__number = $_yes__is_editable__number.properties.edit_mode.state.node;
														const raw_data: Record<string, any> = {};
														raw_edit_mode = raw_data
														break;
													}
													case 'on': {
														const $_on__edit_mode__yes__is_editable__number = $_yes__is_editable__number.properties.edit_mode.state.node;
														const raw_data: Record<string, any> = {};
														raw_edit_mode = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__is_editable__number.properties.edit_mode.state)
												}
												raw_data["edit mode"] = [$_yes__is_editable__number.properties.edit_mode.state.name, raw_edit_mode];
											}
											{
												let raw_modified: Record<string, any>;
												switch ($_yes__is_editable__number.properties.modified.state.name) {
													case 'no': {
														const $_no__modified__yes__is_editable__number = $_yes__is_editable__number.properties.modified.state.node;
														const raw_data: Record<string, any> = {};
														raw_modified = raw_data
														break;
													}
													case 'yes': {
														const $_yes__modified__yes__is_editable__number = $_yes__is_editable__number.properties.modified.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["number"] = $_yes__modified__yes__is_editable__number.properties.number.value;
														raw_modified = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__is_editable__number.properties.modified.state)
												}
												raw_data["modified"] = [$_yes__is_editable__number.properties.modified.state.name, raw_modified];
											}
											raw_is_editable = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_number__type__property.properties.is_editable.state)
									}
									raw_data["is editable"] = [$_number__type__property.properties.is_editable.state.name, raw_is_editable];
								}
								{
									let raw_is_set: Record<string, any>;
									switch ($_number__type__property.properties.is_set.state.name) {
										case 'no': {
											const $_no__is_set__number__type__property = $_number__type__property.properties.is_set.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_set = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_set__number__type__property = $_number__type__property.properties.is_set.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_by: Record<string, any>;
												switch ($_yes__is_set__number__type__property.properties.by.state.name) {
													case 'engine': {
														const $_engine__by__yes__is_set__number = $_yes__is_set__number__type__property.properties.by.state.node;
														const raw_data: Record<string, any> = {};
														raw_by = raw_data
														break;
													}
													case 'user': {
														const $_user__by__yes__is_set__number = $_yes__is_set__number__type__property.properties.by.state.node;
														const raw_data: Record<string, any> = {};
														raw_by = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__is_set__number__type__property.properties.by.state)
												}
												raw_data["by"] = [$_yes__is_set__number__type__property.properties.by.state.name, raw_by];
											}
											raw_data["number"] = $_yes__is_set__number__type__property.properties.number.value;
											raw_is_set = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_number__type__property.properties.is_set.state)
									}
									raw_data["is set"] = [$_number__type__property.properties.is_set.state.name, raw_is_set];
								}
								{
									let raw_is_valid: Record<string, any>;
									switch ($_number__type__property.properties.is_valid.state.name) {
										case 'no': {
											const $_no__is_valid__number__type__property = $_number__type__property.properties.is_valid.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_exceeds_maximum: Record<string, any>;
												switch ($_no__is_valid__number__type__property.properties.exceeds_maximum.state.name) {
													case 'no': {
														const $_no__exceeds_maximum = $_no__is_valid__number__type__property.properties.exceeds_maximum.state.node;
														const raw_data: Record<string, any> = {};
														raw_exceeds_maximum = raw_data
														break;
													}
													case 'yes': {
														const $_yes__exceeds_maximum = $_no__is_valid__number__type__property.properties.exceeds_maximum.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["maximum"] = $_yes__exceeds_maximum.properties.maximum.value;
														raw_exceeds_maximum = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__number__type__property.properties.exceeds_maximum.state)
												}
												raw_data["exceeds maximum"] = [$_no__is_valid__number__type__property.properties.exceeds_maximum.state.name, raw_exceeds_maximum];
											}
											{
												let raw_exceeds_minimum: Record<string, any>;
												switch ($_no__is_valid__number__type__property.properties.exceeds_minimum.state.name) {
													case 'no': {
														const $_no__exceeds_minimum = $_no__is_valid__number__type__property.properties.exceeds_minimum.state.node;
														const raw_data: Record<string, any> = {};
														raw_exceeds_minimum = raw_data
														break;
													}
													case 'yes': {
														const $_yes__exceeds_minimum = $_no__is_valid__number__type__property.properties.exceeds_minimum.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["minimum"] = $_yes__exceeds_minimum.properties.minimum.value;
														raw_exceeds_minimum = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__number__type__property.properties.exceeds_minimum.state)
												}
												raw_data["exceeds minimum"] = [$_no__is_valid__number__type__property.properties.exceeds_minimum.state.name, raw_exceeds_minimum];
											}
											{
												let raw_not_a_number: Record<string, any>;
												switch ($_no__is_valid__number__type__property.properties.not_a_number.state.name) {
													case 'no': {
														const $_no__not_a_number = $_no__is_valid__number__type__property.properties.not_a_number.state.node;
														const raw_data: Record<string, any> = {};
														raw_not_a_number = raw_data
														break;
													}
													case 'yes': {
														const $_yes__not_a_number = $_no__is_valid__number__type__property.properties.not_a_number.state.node;
														const raw_data: Record<string, any> = {};
														raw_not_a_number = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__number__type__property.properties.not_a_number.state)
												}
												raw_data["not a number"] = [$_no__is_valid__number__type__property.properties.not_a_number.state.name, raw_not_a_number];
											}
											{
												let raw_not_set: Record<string, any>;
												switch ($_no__is_valid__number__type__property.properties.not_set.state.name) {
													case 'no': {
														const $_no__not_set__no__is_valid__number = $_no__is_valid__number__type__property.properties.not_set.state.node;
														const raw_data: Record<string, any> = {};
														raw_not_set = raw_data
														break;
													}
													case 'yes': {
														const $_yes__not_set__no__is_valid__number = $_no__is_valid__number__type__property.properties.not_set.state.node;
														const raw_data: Record<string, any> = {};
														raw_not_set = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__number__type__property.properties.not_set.state)
												}
												raw_data["not set"] = [$_no__is_valid__number__type__property.properties.not_set.state.name, raw_not_set];
											}
											{
												let raw_should_be_positive: Record<string, any>;
												switch ($_no__is_valid__number__type__property.properties.should_be_positive.state.name) {
													case 'no': {
														const $_no__should_be_positive = $_no__is_valid__number__type__property.properties.should_be_positive.state.node;
														const raw_data: Record<string, any> = {};
														raw_should_be_positive = raw_data
														break;
													}
													case 'yes': {
														const $_yes__should_be_positive = $_no__is_valid__number__type__property.properties.should_be_positive.state.node;
														const raw_data: Record<string, any> = {};
														raw_should_be_positive = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__number__type__property.properties.should_be_positive.state)
												}
												raw_data["should be positive"] = [$_no__is_valid__number__type__property.properties.should_be_positive.state.name, raw_should_be_positive];
											}
											raw_is_valid = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_valid__number__type__property = $_number__type__property.properties.is_valid.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_valid = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_number__type__property.properties.is_valid.state)
									}
									raw_data["is valid"] = [$_number__type__property.properties.is_valid.state.name, raw_is_valid];
								}
								{
									let raw_number_type: Record<string, any>;
									switch ($_number__type__property.properties.number_type.state.name) {
										case 'integer': {
											const $_integer = $_number__type__property.properties.number_type.state.node;
											const raw_data: Record<string, any> = {};
											raw_number_type = raw_data
											break;
										}
										case 'positive': {
											const $_positive = $_number__type__property.properties.number_type.state.node;
											const raw_data: Record<string, any> = {};
											raw_number_type = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_number__type__property.properties.number_type.state)
									}
									raw_data["number type"] = [$_number__type__property.properties.number_type.state.name, raw_number_type];
								}
								raw_data["numerical type properties"] = serialize_numerical_type_properties($_number__type__property.properties.numerical_type_properties);
								raw_type = raw_data
								break;
							}
							case 'state group': {
								const $_state_group__type__property = $_property.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_initialized: Record<string, any>;
									switch ($_state_group__type__property.properties.initialized.state.name) {
										case 'no': {
											const $_no__initialized__state_group = $_state_group__type__property.properties.initialized.state.node;
											const raw_data: Record<string, any> = {};
											raw_initialized = raw_data
											break;
										}
										case 'yes': {
											const $_yes__initialized__state_group = $_state_group__type__property.properties.initialized.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["state in backend"] = $_yes__initialized__state_group.properties.state_in_backend.entry;
											raw_initialized = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_state_group__type__property.properties.initialized.state)
									}
									raw_data["initialized"] = [$_state_group__type__property.properties.initialized.state.name, raw_initialized];
								}
								{
									let raw_is_editable: Record<string, any>;
									switch ($_state_group__type__property.properties.is_editable.state.name) {
										case 'no': {
											const $_no__is_editable__state_group = $_state_group__type__property.properties.is_editable.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_editable = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_editable__state_group = $_state_group__type__property.properties.is_editable.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_edit_mode: Record<string, any>;
												switch ($_yes__is_editable__state_group.properties.edit_mode.state.name) {
													case 'off': {
														const $_off__edit_mode__yes__is_editable__state_group = $_yes__is_editable__state_group.properties.edit_mode.state.node;
														const raw_data: Record<string, any> = {};
														raw_edit_mode = raw_data
														break;
													}
													case 'on': {
														const $_on__edit_mode__yes__is_editable__state_group = $_yes__is_editable__state_group.properties.edit_mode.state.node;
														const raw_data: Record<string, any> = {};
														raw_edit_mode = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__is_editable__state_group.properties.edit_mode.state)
												}
												raw_data["edit mode"] = [$_yes__is_editable__state_group.properties.edit_mode.state.name, raw_edit_mode];
											}
											raw_is_editable = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_state_group__type__property.properties.is_editable.state)
									}
									raw_data["is editable"] = [$_state_group__type__property.properties.is_editable.state.name, raw_is_editable];
								}
								{
									let raw_is_modified: Record<string, any>;
									switch ($_state_group__type__property.properties.is_modified.state.name) {
										case 'no': {
											const $_no__is_modified = $_state_group__type__property.properties.is_modified.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_modified = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_modified = $_state_group__type__property.properties.is_modified.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_modified = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_state_group__type__property.properties.is_modified.state)
									}
									raw_data["is modified"] = [$_state_group__type__property.properties.is_modified.state.name, raw_is_modified];
								}
								{
									let raw_is_set: Record<string, any>;
									switch ($_state_group__type__property.properties.is_set.state.name) {
										case 'no': {
											const $_no__is_set__state_group__type__property = $_state_group__type__property.properties.is_set.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_set = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_set__state_group__type__property = $_state_group__type__property.properties.is_set.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_by: Record<string, any>;
												switch ($_yes__is_set__state_group__type__property.properties.by.state.name) {
													case 'engine': {
														const $_engine__by__yes__is_set__state_group = $_yes__is_set__state_group__type__property.properties.by.state.node;
														const raw_data: Record<string, any> = {};
														raw_by = raw_data
														break;
													}
													case 'user': {
														const $_user__by__yes__is_set__state_group = $_yes__is_set__state_group__type__property.properties.by.state.node;
														const raw_data: Record<string, any> = {};
														raw_by = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__is_set__state_group__type__property.properties.by.state)
												}
												raw_data["by"] = [$_yes__is_set__state_group__type__property.properties.by.state.name, raw_by];
											}
											raw_data["state"] = $_yes__is_set__state_group__type__property.properties.state.entry;
											raw_is_set = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_state_group__type__property.properties.is_set.state)
									}
									raw_data["is set"] = [$_state_group__type__property.properties.is_set.state.name, raw_is_set];
								}
								{
									let raw_is_valid: Record<string, any>;
									switch ($_state_group__type__property.properties.is_valid.state.name) {
										case 'no': {
											const $_no__is_valid__state_group = $_state_group__type__property.properties.is_valid.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_invalid_rules: Record<string, any>;
												switch ($_no__is_valid__state_group.properties.invalid_rules.state.name) {
													case 'no': {
														const $_no__invalid_rules__no__is_valid__state_group = $_no__is_valid__state_group.properties.invalid_rules.state.node;
														const raw_data: Record<string, any> = {};
														raw_invalid_rules = raw_data
														break;
													}
													case 'yes': {
														const $_yes__invalid_rules__no__is_valid__state_group = $_no__is_valid__state_group.properties.invalid_rules.state.node;
														const raw_data: Record<string, any> = {};
														raw_invalid_rules = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__state_group.properties.invalid_rules.state)
												}
												raw_data["invalid rules"] = [$_no__is_valid__state_group.properties.invalid_rules.state.name, raw_invalid_rules];
											}
											{
												let raw_no_state_selected: Record<string, any>;
												switch ($_no__is_valid__state_group.properties.no_state_selected.state.name) {
													case 'no': {
														const $_no__no_state_selected = $_no__is_valid__state_group.properties.no_state_selected.state.node;
														const raw_data: Record<string, any> = {};
														raw_no_state_selected = raw_data
														break;
													}
													case 'yes': {
														const $_yes__no_state_selected = $_no__is_valid__state_group.properties.no_state_selected.state.node;
														const raw_data: Record<string, any> = {};
														raw_no_state_selected = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__state_group.properties.no_state_selected.state)
												}
												raw_data["no state selected"] = [$_no__is_valid__state_group.properties.no_state_selected.state.name, raw_no_state_selected];
											}
											raw_is_valid = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_valid__state_group = $_state_group__type__property.properties.is_valid.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_valid = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_state_group__type__property.properties.is_valid.state)
									}
									raw_data["is valid"] = [$_state_group__type__property.properties.is_valid.state.name, raw_is_valid];
								}
								const raw_states: Record<string, any> = {};
								for (let [k,v] of $_state_group__type__property.properties.states) {
									const $_states__state_group__type__property = v;
									const raw_data: Record<string, any> = {};
									{
										let raw_create_permitted: Record<string, any>;
										switch ($_states__state_group__type__property.properties.create_permitted.state.name) {
											case 'no': {
												const $_no__create_permitted = $_states__state_group__type__property.properties.create_permitted.state.node;
												const raw_data: Record<string, any> = {};
												raw_create_permitted = raw_data
												break;
											}
											case 'yes': {
												const $_yes__create_permitted = $_states__state_group__type__property.properties.create_permitted.state.node;
												const raw_data: Record<string, any> = {};
												raw_create_permitted = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_states__state_group__type__property.properties.create_permitted.state)
										}
										raw_data["create permitted"] = [$_states__state_group__type__property.properties.create_permitted.state.name, raw_create_permitted];
									}
									{
										let raw_is_selected: Record<string, any>;
										switch ($_states__state_group__type__property.properties.is_selected.state.name) {
											case 'no': {
												const $_no__is_selected__states__state_group__type__property = $_states__state_group__type__property.properties.is_selected.state.node;
												const raw_data: Record<string, any> = {};
												raw_is_selected = raw_data
												break;
											}
											case 'yes': {
												const $_yes__is_selected__states__state_group__type__property = $_states__state_group__type__property.properties.is_selected.state.node;
												const raw_data: Record<string, any> = {};
												raw_is_selected = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_states__state_group__type__property.properties.is_selected.state)
										}
										raw_data["is selected"] = [$_states__state_group__type__property.properties.is_selected.state.name, raw_is_selected];
									}
									{
										let raw_location: Record<string, any>;
										switch ($_states__state_group__type__property.properties.location.state.name) {
											case 'local': {
												const $_local__location__states = $_states__state_group__type__property.properties.location.state.node;
												const raw_data: Record<string, any> = {};
												raw_location = raw_data
												break;
											}
											case 'remote': {
												const $_remote__location__states = $_states__state_group__type__property.properties.location.state.node;
												const raw_data: Record<string, any> = {};
												raw_location = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_states__state_group__type__property.properties.location.state)
										}
										raw_data["location"] = [$_states__state_group__type__property.properties.location.state.name, raw_location];
									}
									raw_data["node"] = serialize_node($_states__state_group__type__property.properties.node);
									raw_data["rules"] = serialize_where_rules($_states__state_group__type__property.properties.rules);
									raw_data["style"] = serialize_style($_states__state_group__type__property.properties.style);
									raw_states[k] = raw_data
								}
								raw_data["states"] = raw_states;
								raw_type = raw_data
								break;
							}
							case 'text': {
								const $_text__type__property = $_property.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_backend_known: Record<string, any>;
									switch ($_text__type__property.properties.backend_known.state.name) {
										case 'no': {
											const $_no__backend_known__text = $_text__type__property.properties.backend_known.state.node;
											const raw_data: Record<string, any> = {};
											raw_backend_known = raw_data
											break;
										}
										case 'yes': {
											const $_yes__backend_known__text = $_text__type__property.properties.backend_known.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["value"] = $_yes__backend_known__text.properties.value;
											raw_backend_known = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_text__type__property.properties.backend_known.state)
									}
									raw_data["backend known"] = [$_text__type__property.properties.backend_known.state.name, raw_backend_known];
								}
								{
									let raw_is_editable: Record<string, any>;
									switch ($_text__type__property.properties.is_editable.state.name) {
										case 'no': {
											const $_no__is_editable__text = $_text__type__property.properties.is_editable.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_editable = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_editable__text = $_text__type__property.properties.is_editable.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_edit_mode: Record<string, any>;
												switch ($_yes__is_editable__text.properties.edit_mode.state.name) {
													case 'off': {
														const $_off__edit_mode__yes__is_editable__text = $_yes__is_editable__text.properties.edit_mode.state.node;
														const raw_data: Record<string, any> = {};
														raw_edit_mode = raw_data
														break;
													}
													case 'on': {
														const $_on__edit_mode__yes__is_editable__text = $_yes__is_editable__text.properties.edit_mode.state.node;
														const raw_data: Record<string, any> = {};
														raw_edit_mode = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__is_editable__text.properties.edit_mode.state)
												}
												raw_data["edit mode"] = [$_yes__is_editable__text.properties.edit_mode.state.name, raw_edit_mode];
											}
											{
												let raw_modified: Record<string, any>;
												switch ($_yes__is_editable__text.properties.modified.state.name) {
													case 'no': {
														const $_no__modified__yes__is_editable__text = $_yes__is_editable__text.properties.modified.state.node;
														const raw_data: Record<string, any> = {};
														raw_modified = raw_data
														break;
													}
													case 'yes': {
														const $_yes__modified__yes__is_editable__text = $_yes__is_editable__text.properties.modified.state.node;
														const raw_data: Record<string, any> = {};
														{
															let raw_saving: Record<string, any>;
															switch ($_yes__modified__yes__is_editable__text.properties.saving.state.name) {
																case 'no': {
																	const $_no__saving = $_yes__modified__yes__is_editable__text.properties.saving.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_saving = raw_data
																	break;
																}
																case 'yes': {
																	const $_yes__saving = $_yes__modified__yes__is_editable__text.properties.saving.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_saving = raw_data
																	break;
																}
																default:
																	throw new Error("unexpected state: " + $_yes__modified__yes__is_editable__text.properties.saving.state)
															}
															raw_data["saving"] = [$_yes__modified__yes__is_editable__text.properties.saving.state.name, raw_saving];
														}
														raw_data["value"] = $_yes__modified__yes__is_editable__text.properties.value;
														raw_modified = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__is_editable__text.properties.modified.state)
												}
												raw_data["modified"] = [$_yes__is_editable__text.properties.modified.state.name, raw_modified];
											}
											raw_is_editable = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_text__type__property.properties.is_editable.state)
									}
									raw_data["is editable"] = [$_text__type__property.properties.is_editable.state.name, raw_is_editable];
								}
								{
									let raw_is_key: Record<string, any>;
									switch ($_text__type__property.properties.is_key.state.name) {
										case 'no': {
											const $_no__is_key = $_text__type__property.properties.is_key.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_key = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_key = $_text__type__property.properties.is_key.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_key_unique: Record<string, any>;
												switch ($_yes__is_key.properties.key_unique.state.name) {
													case 'no': {
														const $_no__key_unique = $_yes__is_key.properties.key_unique.state.node;
														const raw_data: Record<string, any> = {};
														raw_key_unique = raw_data
														break;
													}
													case 'yes': {
														const $_yes__key_unique = $_yes__is_key.properties.key_unique.state.node;
														const raw_data: Record<string, any> = {};
														raw_key_unique = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__is_key.properties.key_unique.state)
												}
												raw_data["key unique"] = [$_yes__is_key.properties.key_unique.state.name, raw_key_unique];
											}
											raw_is_key = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_text__type__property.properties.is_key.state)
									}
									raw_data["is key"] = [$_text__type__property.properties.is_key.state.name, raw_is_key];
								}
								{
									let raw_is_set: Record<string, any>;
									switch ($_text__type__property.properties.is_set.state.name) {
										case 'no': {
											const $_no__is_set__text__type__property = $_text__type__property.properties.is_set.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_set = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_set__text__type__property = $_text__type__property.properties.is_set.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_by: Record<string, any>;
												switch ($_yes__is_set__text__type__property.properties.by.state.name) {
													case 'engine': {
														const $_engine__by__yes__is_set__text = $_yes__is_set__text__type__property.properties.by.state.node;
														const raw_data: Record<string, any> = {};
														raw_by = raw_data
														break;
													}
													case 'user': {
														const $_user__by__yes__is_set__text = $_yes__is_set__text__type__property.properties.by.state.node;
														const raw_data: Record<string, any> = {};
														raw_by = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__is_set__text__type__property.properties.by.state)
												}
												raw_data["by"] = [$_yes__is_set__text__type__property.properties.by.state.name, raw_by];
											}
											raw_data["text"] = $_yes__is_set__text__type__property.properties.text;
											raw_is_set = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_text__type__property.properties.is_set.state)
									}
									raw_data["is set"] = [$_text__type__property.properties.is_set.state.name, raw_is_set];
								}
								{
									let raw_is_valid: Record<string, any>;
									switch ($_text__type__property.properties.is_valid.state.name) {
										case 'no': {
											const $_no__is_valid__text__type__property = $_text__type__property.properties.is_valid.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_invalid_rules: Record<string, any>;
												switch ($_no__is_valid__text__type__property.properties.invalid_rules.state.name) {
													case 'no': {
														const $_no__invalid_rules__no__is_valid__text = $_no__is_valid__text__type__property.properties.invalid_rules.state.node;
														const raw_data: Record<string, any> = {};
														raw_invalid_rules = raw_data
														break;
													}
													case 'yes': {
														const $_yes__invalid_rules__no__is_valid__text = $_no__is_valid__text__type__property.properties.invalid_rules.state.node;
														const raw_data: Record<string, any> = {};
														raw_invalid_rules = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__text__type__property.properties.invalid_rules.state)
												}
												raw_data["invalid rules"] = [$_no__is_valid__text__type__property.properties.invalid_rules.state.name, raw_invalid_rules];
											}
											{
												let raw_key_is_not_unique: Record<string, any>;
												switch ($_no__is_valid__text__type__property.properties.key_is_not_unique.state.name) {
													case 'no': {
														const $_no__key_is_not_unique = $_no__is_valid__text__type__property.properties.key_is_not_unique.state.node;
														const raw_data: Record<string, any> = {};
														raw_key_is_not_unique = raw_data
														break;
													}
													case 'yes': {
														const $_yes__key_is_not_unique = $_no__is_valid__text__type__property.properties.key_is_not_unique.state.node;
														const raw_data: Record<string, any> = {};
														raw_key_is_not_unique = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__text__type__property.properties.key_is_not_unique.state)
												}
												raw_data["key is not unique"] = [$_no__is_valid__text__type__property.properties.key_is_not_unique.state.name, raw_key_is_not_unique];
											}
											{
												let raw_reference_not_resolved: Record<string, any>;
												switch ($_no__is_valid__text__type__property.properties.reference_not_resolved.state.name) {
													case 'no': {
														const $_no__reference_not_resolved = $_no__is_valid__text__type__property.properties.reference_not_resolved.state.node;
														const raw_data: Record<string, any> = {};
														raw_reference_not_resolved = raw_data
														break;
													}
													case 'yes': {
														const $_yes__reference_not_resolved = $_no__is_valid__text__type__property.properties.reference_not_resolved.state.node;
														const raw_data: Record<string, any> = {};
														raw_reference_not_resolved = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__text__type__property.properties.reference_not_resolved.state)
												}
												raw_data["reference not resolved"] = [$_no__is_valid__text__type__property.properties.reference_not_resolved.state.name, raw_reference_not_resolved];
											}
											{
												let raw_referenced_node_not_valid: Record<string, any>;
												switch ($_no__is_valid__text__type__property.properties.referenced_node_not_valid.state.name) {
													case 'no': {
														const $_no__referenced_node_not_valid = $_no__is_valid__text__type__property.properties.referenced_node_not_valid.state.node;
														const raw_data: Record<string, any> = {};
														raw_referenced_node_not_valid = raw_data
														break;
													}
													case 'yes': {
														const $_yes__referenced_node_not_valid = $_no__is_valid__text__type__property.properties.referenced_node_not_valid.state.node;
														const raw_data: Record<string, any> = {};
														raw_referenced_node_not_valid = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__text__type__property.properties.referenced_node_not_valid.state)
												}
												raw_data["referenced node not valid"] = [$_no__is_valid__text__type__property.properties.referenced_node_not_valid.state.name, raw_referenced_node_not_valid];
											}
											{
												let raw_text_does_not_match_pattern: Record<string, any>;
												switch ($_no__is_valid__text__type__property.properties.text_does_not_match_pattern.state.name) {
													case 'no': {
														const $_no__text_does_not_match_pattern = $_no__is_valid__text__type__property.properties.text_does_not_match_pattern.state.node;
														const raw_data: Record<string, any> = {};
														raw_text_does_not_match_pattern = raw_data
														break;
													}
													case 'yes': {
														const $_yes__text_does_not_match_pattern = $_no__is_valid__text__type__property.properties.text_does_not_match_pattern.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["pattern"] = $_yes__text_does_not_match_pattern.properties.pattern;
														raw_text_does_not_match_pattern = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_no__is_valid__text__type__property.properties.text_does_not_match_pattern.state)
												}
												raw_data["text does not match pattern"] = [$_no__is_valid__text__type__property.properties.text_does_not_match_pattern.state.name, raw_text_does_not_match_pattern];
											}
											raw_is_valid = raw_data
											break;
										}
										case 'yes': {
											const $_yes__is_valid__text__type__property = $_text__type__property.properties.is_valid.state.node;
											const raw_data: Record<string, any> = {};
											raw_is_valid = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_text__type__property.properties.is_valid.state)
									}
									raw_data["is valid"] = [$_text__type__property.properties.is_valid.state.name, raw_is_valid];
								}
								{
									let raw_navigable: Record<string, any>;
									switch ($_text__type__property.properties.navigable.state.name) {
										case 'no': {
											const $_no__navigable = $_text__type__property.properties.navigable.state.node;
											const raw_data: Record<string, any> = {};
											raw_navigable = raw_data
											break;
										}
										case 'yes': {
											const $_yes__navigable = $_text__type__property.properties.navigable.state.node;
											const raw_data: Record<string, any> = {};
											const raw_queries: Record<string, any> = {};
											for (let [k,v] of $_yes__navigable.properties.queries) {
												const $_queries__yes = v;
												const raw_data: Record<string, any> = {};
												raw_data["query"] = serialize_query($_queries__yes.properties.query);
												raw_queries[k] = raw_data
											}
											raw_data["queries"] = raw_queries;
											raw_data["resolve status"] = serialize_resolve_status($_yes__navigable.properties.resolve_status);
											raw_data["rules"] = serialize_where_rules($_yes__navigable.properties.rules);
											{
												let raw_type: Record<string, any>;
												switch ($_yes__navigable.properties.type.state.name) {
													case 'mandatory': {
														const $_mandatory = $_yes__navigable.properties.type.state.node;
														const raw_data: Record<string, any> = {};
														raw_type = raw_data
														break;
													}
													case 'optional': {
														const $_optional = $_yes__navigable.properties.type.state.node;
														const raw_data: Record<string, any> = {};
														raw_type = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__navigable.properties.type.state)
												}
												raw_data["type"] = [$_yes__navigable.properties.type.state.name, raw_type];
											}
											raw_navigable = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_text__type__property.properties.navigable.state)
									}
									raw_data["navigable"] = [$_text__type__property.properties.navigable.state.name, raw_navigable];
								}
								{
									let raw_validation_result: Record<string, any>;
									switch ($_text__type__property.properties.validation_result.state.name) {
										case 'failure': {
											const $_failure__validation_result__text = $_text__type__property.properties.validation_result.state.node;
											const raw_data: Record<string, any> = {};
											raw_validation_result = raw_data
											break;
										}
										case 'success': {
											const $_success__validation_result__text = $_text__type__property.properties.validation_result.state.node;
											const raw_data: Record<string, any> = {};
											raw_validation_result = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_text__type__property.properties.validation_result.state)
									}
									raw_data["validation result"] = [$_text__type__property.properties.validation_result.state.name, raw_validation_result];
								}
								raw_type = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_property.properties.type.state)
						}
						raw_data["type"] = [$_property.properties.type.state.name, raw_type];
					}
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_attributes.properties.type.state)
			}
			raw_data["type"] = [$_attributes.properties.type.state.name, raw_type];
		}
		raw_attributes[k] = raw_data
	}
	raw_data["attributes"] = raw_attributes;
	{
		let raw_can_be_deleted: Record<string, any>;
		switch ($_node.properties.can_be_deleted.state.name) {
			case 'no': {
				const $_no__can_be_deleted = $_node.properties.can_be_deleted.state.node;
				const raw_data: Record<string, any> = {};
				raw_can_be_deleted = raw_data
				break;
			}
			case 'yes': {
				const $_yes__can_be_deleted = $_node.properties.can_be_deleted.state.node;
				const raw_data: Record<string, any> = {};
				raw_can_be_deleted = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node.properties.can_be_deleted.state)
		}
		raw_data["can be deleted"] = [$_node.properties.can_be_deleted.state.name, raw_can_be_deleted];
	}
	{
		let raw_is_busy_discarding: Record<string, any>;
		switch ($_node.properties.is_busy_discarding.state.name) {
			case 'no': {
				const $_no__is_busy_discarding = $_node.properties.is_busy_discarding.state.node;
				const raw_data: Record<string, any> = {};
				raw_is_busy_discarding = raw_data
				break;
			}
			case 'yes': {
				const $_yes__is_busy_discarding = $_node.properties.is_busy_discarding.state.node;
				const raw_data: Record<string, any> = {};
				raw_is_busy_discarding = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node.properties.is_busy_discarding.state)
		}
		raw_data["is busy discarding"] = [$_node.properties.is_busy_discarding.state.name, raw_is_busy_discarding];
	}
	{
		let raw_is_busy_saving: Record<string, any>;
		switch ($_node.properties.is_busy_saving.state.name) {
			case 'no': {
				const $_no__is_busy_saving = $_node.properties.is_busy_saving.state.node;
				const raw_data: Record<string, any> = {};
				raw_is_busy_saving = raw_data
				break;
			}
			case 'yes': {
				const $_yes__is_busy_saving = $_node.properties.is_busy_saving.state.node;
				const raw_data: Record<string, any> = {};
				raw_is_busy_saving = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node.properties.is_busy_saving.state)
		}
		raw_data["is busy saving"] = [$_node.properties.is_busy_saving.state.name, raw_is_busy_saving];
	}
	{
		let raw_is_valid: Record<string, any>;
		switch ($_node.properties.is_valid.state.name) {
			case 'no': {
				const $_no__is_valid__node = $_node.properties.is_valid.state.node;
				const raw_data: Record<string, any> = {};
				raw_is_valid = raw_data
				break;
			}
			case 'yes': {
				const $_yes__is_valid__node = $_node.properties.is_valid.state.node;
				const raw_data: Record<string, any> = {};
				raw_is_valid = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node.properties.is_valid.state)
		}
		raw_data["is valid"] = [$_node.properties.is_valid.state.name, raw_is_valid];
	}
	{
		let raw_location: Record<string, any>;
		switch ($_node.properties.location.state.name) {
			case 'local': {
				const $_local__location__node = $_node.properties.location.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_parent_location: Record<string, any>;
					switch ($_local__location__node.properties.parent_location.state.name) {
						case 'local': {
							const $_local__parent_location = $_local__location__node.properties.parent_location.state.node;
							const raw_data: Record<string, any> = {};
							raw_parent_location = raw_data
							break;
						}
						case 'remote': {
							const $_remote__parent_location = $_local__location__node.properties.parent_location.state.node;
							const raw_data: Record<string, any> = {};
							raw_parent_location = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_local__location__node.properties.parent_location.state)
					}
					raw_data["parent location"] = [$_local__location__node.properties.parent_location.state.name, raw_parent_location];
				}
				raw_location = raw_data
				break;
			}
			case 'remote': {
				const $_remote__location__node = $_node.properties.location.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_edit_mode: Record<string, any>;
					switch ($_remote__location__node.properties.edit_mode.state.name) {
						case 'off': {
							const $_off__edit_mode__remote = $_remote__location__node.properties.edit_mode.state.node;
							const raw_data: Record<string, any> = {};
							raw_edit_mode = raw_data
							break;
						}
						case 'on': {
							const $_on__edit_mode__remote = $_remote__location__node.properties.edit_mode.state.node;
							const raw_data: Record<string, any> = {};
							raw_edit_mode = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_remote__location__node.properties.edit_mode.state)
					}
					raw_data["edit mode"] = [$_remote__location__node.properties.edit_mode.state.name, raw_edit_mode];
				}
				raw_location = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node.properties.location.state)
		}
		raw_data["location"] = [$_node.properties.location.state.name, raw_location];
	}
	{
		let raw_modified: Record<string, any>;
		switch ($_node.properties.modified.state.name) {
			case 'no': {
				const $_no__modified__node = $_node.properties.modified.state.node;
				const raw_data: Record<string, any> = {};
				raw_modified = raw_data
				break;
			}
			case 'yes': {
				const $_yes__modified__node = $_node.properties.modified.state.node;
				const raw_data: Record<string, any> = {};
				raw_modified = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node.properties.modified.state)
		}
		raw_data["modified"] = [$_node.properties.modified.state.name, raw_modified];
	}
	const raw_queries: Record<string, any> = {};
	for (let [k,v] of $_node.properties.queries) {
		const $_queries__node = v;
		const raw_data: Record<string, any> = {};
		raw_data["query"] = serialize_query($_queries__node.properties.query);
		raw_queries[k] = raw_data
	}
	raw_data["queries"] = raw_queries;
	{
		let raw_read_permitted: Record<string, any>;
		switch ($_node.properties.read_permitted.state.name) {
			case 'no': {
				const $_no__read_permitted = $_node.properties.read_permitted.state.node;
				const raw_data: Record<string, any> = {};
				raw_read_permitted = raw_data
				break;
			}
			case 'yes': {
				const $_yes__read_permitted = $_node.properties.read_permitted.state.node;
				const raw_data: Record<string, any> = {};
				raw_read_permitted = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node.properties.read_permitted.state)
		}
		raw_data["read permitted"] = [$_node.properties.read_permitted.state.name, raw_read_permitted];
	}
	const raw_report_types: Record<string, any> = {};
	for (let [k,v] of $_node.properties.report_types) {
		const $_report_types__node = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_initialized: Record<string, any>;
			switch ($_report_types__node.properties.initialized.state.name) {
				case 'no': {
					const $_no__initialized__report_types = $_report_types__node.properties.initialized.state.node;
					const raw_data: Record<string, any> = {};
					raw_initialized = raw_data
					break;
				}
				case 'yes': {
					const $_yes__initialized__report_types = $_report_types__node.properties.initialized.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["parameters"] = serialize_report_parameters($_yes__initialized__report_types.properties.parameters);
					const raw_templates: Record<string, any> = {};
					for (let [k,v] of $_yes__initialized__report_types.properties.templates) {
						const $_templates = v;
						const raw_data: Record<string, any> = {};
						raw_templates[k] = raw_data
					}
					raw_data["templates"] = raw_templates;
					raw_initialized = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_report_types__node.properties.initialized.state)
			}
			raw_data["initialized"] = [$_report_types__node.properties.initialized.state.name, raw_initialized];
		}
		raw_report_types[k] = raw_data
	}
	raw_data["report types"] = raw_report_types;
	{
		let raw_todo: Record<string, any>;
		switch ($_node.properties.todo.state.name) {
			case 'no': {
				const $_no__todo = $_node.properties.todo.state.node;
				const raw_data: Record<string, any> = {};
				raw_todo = raw_data
				break;
			}
			case 'yes': {
				const $_yes__todo = $_node.properties.todo.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_for_: Record<string, any>;
					switch ($_yes__todo.properties.for_.state.name) {
						case 'current user': {
							const $_current_user = $_yes__todo.properties.for_.state.node;
							const raw_data: Record<string, any> = {};
							{
								let raw_and: Record<string, any>;
								switch ($_current_user.properties.and.state.name) {
									case 'no one else': {
										const $_no_one_else = $_current_user.properties.and.state.node;
										const raw_data: Record<string, any> = {};
										raw_and = raw_data
										break;
									}
									case 'others': {
										const $_others = $_current_user.properties.and.state.node;
										const raw_data: Record<string, any> = {};
										raw_and = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_current_user.properties.and.state)
								}
								raw_data["and"] = [$_current_user.properties.and.state.name, raw_and];
							}
							raw_for_ = raw_data
							break;
						}
						case 'someone else': {
							const $_someone_else = $_yes__todo.properties.for_.state.node;
							const raw_data: Record<string, any> = {};
							raw_for_ = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__todo.properties.for_.state)
					}
					raw_data["for"] = [$_yes__todo.properties.for_.state.name, raw_for_];
				}
				raw_todo = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node.properties.todo.state)
		}
		raw_data["todo"] = [$_node.properties.todo.state.name, raw_todo];
	}
	return raw_data;
}
function serialize_numerical_type_properties($_numerical_type_properties: read_api.Cnumerical_type_properties) {
	const raw_data: Record<string, any> = {};
	{
		let raw_initialized: Record<string, any>;
		switch ($_numerical_type_properties.properties.initialized.state.name) {
			case 'no': {
				const $_no__initialized__numerical_type_properties = $_numerical_type_properties.properties.initialized.state.node;
				const raw_data: Record<string, any> = {};
				raw_initialized = raw_data
				break;
			}
			case 'yes': {
				const $_yes__initialized__numerical_type_properties = $_numerical_type_properties.properties.initialized.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["decimals"] = $_yes__initialized__numerical_type_properties.properties.decimals.value;
				raw_data["unit"] = $_yes__initialized__numerical_type_properties.properties.unit;
				raw_initialized = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_numerical_type_properties.properties.initialized.state)
		}
		raw_data["initialized"] = [$_numerical_type_properties.properties.initialized.state.name, raw_initialized];
	}
	return raw_data;
}
function serialize_query($_query__client_state: read_api.Cquery__client_state) {
	const raw_data: Record<string, any> = {};
	{
		let raw_can_download_files: Record<string, any>;
		switch ($_query__client_state.properties.can_download_files.state.name) {
			case 'no': {
				const $_no__can_download_files__query = $_query__client_state.properties.can_download_files.state.node;
				const raw_data: Record<string, any> = {};
				raw_can_download_files = raw_data
				break;
			}
			case 'yes': {
				const $_yes__can_download_files__query = $_query__client_state.properties.can_download_files.state.node;
				const raw_data: Record<string, any> = {};
				raw_can_download_files = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_query__client_state.properties.can_download_files.state)
		}
		raw_data["can download files"] = [$_query__client_state.properties.can_download_files.state.name, raw_can_download_files];
	}
	const raw_columns: Record<string, any> = {};
	for (let [k,v] of $_query__client_state.properties.columns) {
		const $_columns = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_column_type: Record<string, any>;
			switch ($_columns.properties.column_type.state.name) {
				case 'content': {
					const $_content__column_type__columns = $_columns.properties.column_type.state.node;
					const raw_data: Record<string, any> = {};
					raw_column_type = raw_data
					break;
				}
				case 'id': {
					const $_id__column_type__columns = $_columns.properties.column_type.state.node;
					const raw_data: Record<string, any> = {};
					raw_column_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_columns.properties.column_type.state)
			}
			raw_data["column type"] = [$_columns.properties.column_type.state.name, raw_column_type];
		}
		{
			let raw_has_successor: Record<string, any>;
			switch ($_columns.properties.has_successor.state.name) {
				case 'no': {
					const $_no__has_successor__columns = $_columns.properties.has_successor.state.node;
					const raw_data: Record<string, any> = {};
					raw_has_successor = raw_data
					break;
				}
				case 'yes': {
					const $_yes__has_successor__columns = $_columns.properties.has_successor.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["successor"] = $_yes__has_successor__columns.properties.successor.entry;
					raw_has_successor = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_columns.properties.has_successor.state)
			}
			raw_data["has successor"] = [$_columns.properties.has_successor.state.name, raw_has_successor];
		}
		raw_data["name"] = $_columns.properties.name;
		{
			let raw_type: Record<string, any>;
			switch ($_columns.properties.type.state.name) {
				case 'file': {
					const $_file__type__columns = $_columns.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_type = raw_data
					break;
				}
				case 'number': {
					const $_number__type__columns = $_columns.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_has_filter: Record<string, any>;
						switch ($_number__type__columns.properties.has_filter.state.name) {
							case 'no': {
								const $_no__has_filter__number = $_number__type__columns.properties.has_filter.state.node;
								const raw_data: Record<string, any> = {};
								raw_has_filter = raw_data
								break;
							}
							case 'yes': {
								const $_yes__has_filter__number = $_number__type__columns.properties.has_filter.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_criteria_is_valid: Record<string, any>;
									switch ($_yes__has_filter__number.properties.criteria_is_valid.state.name) {
										case 'no': {
											const $_no__criteria_is_valid__yes__has_filter = $_yes__has_filter__number.properties.criteria_is_valid.state.node;
											const raw_data: Record<string, any> = {};
											raw_criteria_is_valid = raw_data
											break;
										}
										case 'yes': {
											const $_yes__criteria_is_valid__yes__has_filter = $_yes__has_filter__number.properties.criteria_is_valid.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["criteria"] = $_yes__criteria_is_valid__yes__has_filter.properties.criteria.value;
											raw_criteria_is_valid = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__has_filter__number.properties.criteria_is_valid.state)
									}
									raw_data["criteria is valid"] = [$_yes__has_filter__number.properties.criteria_is_valid.state.name, raw_criteria_is_valid];
								}
								{
									let raw_filter_range: Record<string, any>;
									switch ($_yes__has_filter__number.properties.filter_range.state.name) {
										case 'no': {
											const $_no__filter_range = $_yes__has_filter__number.properties.filter_range.state.node;
											const raw_data: Record<string, any> = {};
											raw_filter_range = raw_data
											break;
										}
										case 'not available': {
											const $_not_available = $_yes__has_filter__number.properties.filter_range.state.node;
											const raw_data: Record<string, any> = {};
											raw_filter_range = raw_data
											break;
										}
										case 'yes': {
											const $_yes__filter_range = $_yes__has_filter__number.properties.filter_range.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_criteria_is_valid: Record<string, any>;
												switch ($_yes__filter_range.properties.criteria_is_valid.state.name) {
													case 'no': {
														const $_no__criteria_is_valid__yes__filter_range = $_yes__filter_range.properties.criteria_is_valid.state.node;
														const raw_data: Record<string, any> = {};
														raw_criteria_is_valid = raw_data
														break;
													}
													case 'yes': {
														const $_yes__criteria_is_valid__yes__filter_range = $_yes__filter_range.properties.criteria_is_valid.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["criteria"] = $_yes__criteria_is_valid__yes__filter_range.properties.criteria.value;
														raw_criteria_is_valid = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__filter_range.properties.criteria_is_valid.state)
												}
												raw_data["criteria is valid"] = [$_yes__filter_range.properties.criteria_is_valid.state.name, raw_criteria_is_valid];
											}
											{
												let raw_operator: Record<string, any>;
												switch ($_yes__filter_range.properties.operator.state.name) {
													case 'greater than': {
														const $_greater_than__operator__yes__filter_range = $_yes__filter_range.properties.operator.state.node;
														const raw_data: Record<string, any> = {};
														{
															let raw_or_equal_to: Record<string, any>;
															switch ($_greater_than__operator__yes__filter_range.properties.or_equal_to.state.name) {
																case 'no': {
																	const $_no__or_equal_to__greater_than = $_greater_than__operator__yes__filter_range.properties.or_equal_to.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_or_equal_to = raw_data
																	break;
																}
																case 'yes': {
																	const $_yes__or_equal_to__greater_than = $_greater_than__operator__yes__filter_range.properties.or_equal_to.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_or_equal_to = raw_data
																	break;
																}
																default:
																	throw new Error("unexpected state: " + $_greater_than__operator__yes__filter_range.properties.or_equal_to.state)
															}
															raw_data["or equal to"] = [$_greater_than__operator__yes__filter_range.properties.or_equal_to.state.name, raw_or_equal_to];
														}
														raw_operator = raw_data
														break;
													}
													case 'smaller than': {
														const $_smaller_than__operator__yes__filter_range = $_yes__filter_range.properties.operator.state.node;
														const raw_data: Record<string, any> = {};
														{
															let raw_or_equal_to: Record<string, any>;
															switch ($_smaller_than__operator__yes__filter_range.properties.or_equal_to.state.name) {
																case 'no': {
																	const $_no__or_equal_to__smaller_than = $_smaller_than__operator__yes__filter_range.properties.or_equal_to.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_or_equal_to = raw_data
																	break;
																}
																case 'yes': {
																	const $_yes__or_equal_to__smaller_than = $_smaller_than__operator__yes__filter_range.properties.or_equal_to.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_or_equal_to = raw_data
																	break;
																}
																default:
																	throw new Error("unexpected state: " + $_smaller_than__operator__yes__filter_range.properties.or_equal_to.state)
															}
															raw_data["or equal to"] = [$_smaller_than__operator__yes__filter_range.properties.or_equal_to.state.name, raw_or_equal_to];
														}
														raw_operator = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__filter_range.properties.operator.state)
												}
												raw_data["operator"] = [$_yes__filter_range.properties.operator.state.name, raw_operator];
											}
											raw_filter_range = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__has_filter__number.properties.filter_range.state)
									}
									raw_data["filter range"] = [$_yes__has_filter__number.properties.filter_range.state.name, raw_filter_range];
								}
								{
									let raw_filter_set: Record<string, any>;
									switch ($_yes__has_filter__number.properties.filter_set.state.name) {
										case 'no': {
											const $_no__filter_set__yes__has_filter__number = $_yes__has_filter__number.properties.filter_set.state.node;
											const raw_data: Record<string, any> = {};
											raw_filter_set = raw_data
											break;
										}
										case 'yes': {
											const $_yes__filter_set__yes__has_filter__number = $_yes__has_filter__number.properties.filter_set.state.node;
											const raw_data: Record<string, any> = {};
											raw_filter_set = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__has_filter__number.properties.filter_set.state)
									}
									raw_data["filter set"] = [$_yes__has_filter__number.properties.filter_set.state.name, raw_filter_set];
								}
								{
									let raw_has_default_filter: Record<string, any>;
									switch ($_yes__has_filter__number.properties.has_default_filter.state.name) {
										case 'no': {
											const $_no__has_default_filter__yes__has_filter__number = $_yes__has_filter__number.properties.has_default_filter.state.node;
											const raw_data: Record<string, any> = {};
											raw_has_default_filter = raw_data
											break;
										}
										case 'yes': {
											const $_yes__has_default_filter__yes__has_filter__number = $_yes__has_filter__number.properties.has_default_filter.state.node;
											const raw_data: Record<string, any> = {};
											raw_has_default_filter = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__has_filter__number.properties.has_default_filter.state)
									}
									raw_data["has default filter"] = [$_yes__has_filter__number.properties.has_default_filter.state.name, raw_has_default_filter];
								}
								raw_data["numerical type properties"] = serialize_numerical_type_properties($_yes__has_filter__number.properties.numerical_type_properties);
								{
									let raw_operator_selected: Record<string, any>;
									switch ($_yes__has_filter__number.properties.operator_selected.state.name) {
										case 'no': {
											const $_no__operator_selected = $_yes__has_filter__number.properties.operator_selected.state.node;
											const raw_data: Record<string, any> = {};
											raw_operator_selected = raw_data
											break;
										}
										case 'yes': {
											const $_yes__operator_selected = $_yes__has_filter__number.properties.operator_selected.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_operator: Record<string, any>;
												switch ($_yes__operator_selected.properties.operator.state.name) {
													case 'equal to': {
														const $_equal_to = $_yes__operator_selected.properties.operator.state.node;
														const raw_data: Record<string, any> = {};
														raw_operator = raw_data
														break;
													}
													case 'greater than': {
														const $_greater_than__operator__yes__operator_selected = $_yes__operator_selected.properties.operator.state.node;
														const raw_data: Record<string, any> = {};
														raw_operator = raw_data
														break;
													}
													case 'greater than or equal to': {
														const $_greater_than_or_equal_to = $_yes__operator_selected.properties.operator.state.node;
														const raw_data: Record<string, any> = {};
														raw_operator = raw_data
														break;
													}
													case 'smaller than': {
														const $_smaller_than__operator__yes__operator_selected = $_yes__operator_selected.properties.operator.state.node;
														const raw_data: Record<string, any> = {};
														raw_operator = raw_data
														break;
													}
													case 'smaller than or equal to': {
														const $_smaller_than_or_equal_to = $_yes__operator_selected.properties.operator.state.node;
														const raw_data: Record<string, any> = {};
														raw_operator = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__operator_selected.properties.operator.state)
												}
												raw_data["operator"] = [$_yes__operator_selected.properties.operator.state.name, raw_operator];
											}
											raw_operator_selected = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__has_filter__number.properties.operator_selected.state)
									}
									raw_data["operator selected"] = [$_yes__has_filter__number.properties.operator_selected.state.name, raw_operator_selected];
								}
								raw_has_filter = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_number__type__columns.properties.has_filter.state)
						}
						raw_data["has filter"] = [$_number__type__columns.properties.has_filter.state.name, raw_has_filter];
					}
					raw_type = raw_data
					break;
				}
				case 'state group': {
					const $_state_group__type__columns = $_columns.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_has_filter: Record<string, any>;
						switch ($_state_group__type__columns.properties.has_filter.state.name) {
							case 'no': {
								const $_no__has_filter__state_group = $_state_group__type__columns.properties.has_filter.state.node;
								const raw_data: Record<string, any> = {};
								raw_has_filter = raw_data
								break;
							}
							case 'yes': {
								const $_yes__has_filter__state_group = $_state_group__type__columns.properties.has_filter.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_filter_enabled: Record<string, any>;
									switch ($_yes__has_filter__state_group.properties.filter_enabled.state.name) {
										case 'no': {
											const $_no__filter_enabled = $_yes__has_filter__state_group.properties.filter_enabled.state.node;
											const raw_data: Record<string, any> = {};
											raw_filter_enabled = raw_data
											break;
										}
										case 'yes': {
											const $_yes__filter_enabled = $_yes__has_filter__state_group.properties.filter_enabled.state.node;
											const raw_data: Record<string, any> = {};
											raw_filter_enabled = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__has_filter__state_group.properties.filter_enabled.state)
									}
									raw_data["filter enabled"] = [$_yes__has_filter__state_group.properties.filter_enabled.state.name, raw_filter_enabled];
								}
								{
									let raw_has_default_filter: Record<string, any>;
									switch ($_yes__has_filter__state_group.properties.has_default_filter.state.name) {
										case 'no': {
											const $_no__has_default_filter__yes__has_filter__state_group = $_yes__has_filter__state_group.properties.has_default_filter.state.node;
											const raw_data: Record<string, any> = {};
											raw_has_default_filter = raw_data
											break;
										}
										case 'yes': {
											const $_yes__has_default_filter__yes__has_filter__state_group = $_yes__has_filter__state_group.properties.has_default_filter.state.node;
											const raw_data: Record<string, any> = {};
											raw_has_default_filter = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__has_filter__state_group.properties.has_default_filter.state)
									}
									raw_data["has default filter"] = [$_yes__has_filter__state_group.properties.has_default_filter.state.name, raw_has_default_filter];
								}
								const raw_states: Record<string, any> = {};
								for (let [k,v] of $_yes__has_filter__state_group.properties.states) {
									const $_states__yes = v;
									const raw_data: Record<string, any> = {};
									{
										let raw_is_selected: Record<string, any>;
										switch ($_states__yes.properties.is_selected.state.name) {
											case 'no': {
												const $_no__is_selected__states__yes = $_states__yes.properties.is_selected.state.node;
												const raw_data: Record<string, any> = {};
												raw_is_selected = raw_data
												break;
											}
											case 'yes': {
												const $_yes__is_selected__states__yes = $_states__yes.properties.is_selected.state.node;
												const raw_data: Record<string, any> = {};
												raw_is_selected = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_states__yes.properties.is_selected.state)
										}
										raw_data["is selected"] = [$_states__yes.properties.is_selected.state.name, raw_is_selected];
									}
									raw_data["name"] = $_states__yes.properties.name;
									raw_states[k] = raw_data
								}
								raw_data["states"] = raw_states;
								raw_has_filter = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_state_group__type__columns.properties.has_filter.state)
						}
						raw_data["has filter"] = [$_state_group__type__columns.properties.has_filter.state.name, raw_has_filter];
					}
					raw_type = raw_data
					break;
				}
				case 'text': {
					const $_text__type__columns = $_columns.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_filter_on_current_id_path: Record<string, any>;
						switch ($_text__type__columns.properties.filter_on_current_id_path.state.name) {
							case 'no': {
								const $_no__filter_on_current_id_path = $_text__type__columns.properties.filter_on_current_id_path.state.node;
								const raw_data: Record<string, any> = {};
								raw_filter_on_current_id_path = raw_data
								break;
							}
							case 'yes': {
								const $_yes__filter_on_current_id_path = $_text__type__columns.properties.filter_on_current_id_path.state.node;
								const raw_data: Record<string, any> = {};
								raw_filter_on_current_id_path = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_text__type__columns.properties.filter_on_current_id_path.state)
						}
						raw_data["filter on current id path"] = [$_text__type__columns.properties.filter_on_current_id_path.state.name, raw_filter_on_current_id_path];
					}
					{
						let raw_has_filter: Record<string, any>;
						switch ($_text__type__columns.properties.has_filter.state.name) {
							case 'no': {
								const $_no__has_filter__text = $_text__type__columns.properties.has_filter.state.node;
								const raw_data: Record<string, any> = {};
								raw_has_filter = raw_data
								break;
							}
							case 'yes': {
								const $_yes__has_filter__text = $_text__type__columns.properties.has_filter.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_filter_set: Record<string, any>;
									switch ($_yes__has_filter__text.properties.filter_set.state.name) {
										case 'no': {
											const $_no__filter_set__yes__has_filter__text = $_yes__has_filter__text.properties.filter_set.state.node;
											const raw_data: Record<string, any> = {};
											raw_filter_set = raw_data
											break;
										}
										case 'yes': {
											const $_yes__filter_set__yes__has_filter__text = $_yes__has_filter__text.properties.filter_set.state.node;
											const raw_data: Record<string, any> = {};
											raw_filter_set = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__has_filter__text.properties.filter_set.state)
									}
									raw_data["filter set"] = [$_yes__has_filter__text.properties.filter_set.state.name, raw_filter_set];
								}
								{
									let raw_has_default_filter: Record<string, any>;
									switch ($_yes__has_filter__text.properties.has_default_filter.state.name) {
										case 'no': {
											const $_no__has_default_filter__yes__has_filter__text = $_yes__has_filter__text.properties.has_default_filter.state.node;
											const raw_data: Record<string, any> = {};
											raw_has_default_filter = raw_data
											break;
										}
										case 'yes': {
											const $_yes__has_default_filter__yes__has_filter__text = $_yes__has_filter__text.properties.has_default_filter.state.node;
											const raw_data: Record<string, any> = {};
											raw_has_default_filter = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__has_filter__text.properties.has_default_filter.state)
									}
									raw_data["has default filter"] = [$_yes__has_filter__text.properties.has_default_filter.state.name, raw_has_default_filter];
								}
								{
									let raw_operation: Record<string, any>;
									switch ($_yes__has_filter__text.properties.operation.state.name) {
										case 'contains': {
											const $_contains = $_yes__has_filter__text.properties.operation.state.node;
											const raw_data: Record<string, any> = {};
											raw_operation = raw_data
											break;
										}
										case 'ends with': {
											const $_ends_with = $_yes__has_filter__text.properties.operation.state.node;
											const raw_data: Record<string, any> = {};
											raw_operation = raw_data
											break;
										}
										case 'equals': {
											const $_equals = $_yes__has_filter__text.properties.operation.state.node;
											const raw_data: Record<string, any> = {};
											raw_operation = raw_data
											break;
										}
										case 'starts with': {
											const $_starts_with = $_yes__has_filter__text.properties.operation.state.node;
											const raw_data: Record<string, any> = {};
											raw_operation = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__has_filter__text.properties.operation.state)
									}
									raw_data["operation"] = [$_yes__has_filter__text.properties.operation.state.name, raw_operation];
								}
								raw_data["value"] = $_yes__has_filter__text.properties.value;
								raw_has_filter = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_text__type__columns.properties.has_filter.state)
						}
						raw_data["has filter"] = [$_text__type__columns.properties.has_filter.state.name, raw_has_filter];
					}
					raw_type = raw_data
					break;
				}
				case 'widget': {
					const $_widget__type__columns = $_columns.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_columns.properties.type.state)
			}
			raw_data["type"] = [$_columns.properties.type.state.name, raw_type];
		}
		raw_columns[k] = raw_data
	}
	raw_data["columns"] = raw_columns;
	raw_data["definition"] = $_query__client_state.properties.definition.entry;
	{
		let raw_delay_query: Record<string, any>;
		switch ($_query__client_state.properties.delay_query.state.name) {
			case 'no': {
				const $_no__delay_query = $_query__client_state.properties.delay_query.state.node;
				const raw_data: Record<string, any> = {};
				raw_delay_query = raw_data
				break;
			}
			case 'yes': {
				const $_yes__delay_query = $_query__client_state.properties.delay_query.state.node;
				const raw_data: Record<string, any> = {};
				raw_delay_query = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_query__client_state.properties.delay_query.state)
		}
		raw_data["delay query"] = [$_query__client_state.properties.delay_query.state.name, raw_delay_query];
	}
	{
		let raw_entries_are_editable: Record<string, any>;
		switch ($_query__client_state.properties.entries_are_editable.state.name) {
			case 'no': {
				const $_no__entries_are_editable = $_query__client_state.properties.entries_are_editable.state.node;
				const raw_data: Record<string, any> = {};
				raw_entries_are_editable = raw_data
				break;
			}
			case 'yes': {
				const $_yes__entries_are_editable = $_query__client_state.properties.entries_are_editable.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_can_create_entry: Record<string, any>;
					switch ($_yes__entries_are_editable.properties.can_create_entry.state.name) {
						case 'no': {
							const $_no__can_create_entry__yes = $_yes__entries_are_editable.properties.can_create_entry.state.node;
							const raw_data: Record<string, any> = {};
							raw_can_create_entry = raw_data
							break;
						}
						case 'yes': {
							const $_yes__can_create_entry__yes = $_yes__entries_are_editable.properties.can_create_entry.state.node;
							const raw_data: Record<string, any> = {};
							{
								let raw_in_: Record<string, any>;
								switch ($_yes__can_create_entry__yes.properties.in_.state.name) {
									case 'candidates': {
										const $_candidates__in = $_yes__can_create_entry__yes.properties.in_.state.node;
										const raw_data: Record<string, any> = {};
										raw_in_ = raw_data
										break;
									}
									case 'query': {
										const $_query__in = $_yes__can_create_entry__yes.properties.in_.state.node;
										const raw_data: Record<string, any> = {};
										raw_data["collection"] = $_query__in.properties.collection.entry;
										raw_in_ = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_yes__can_create_entry__yes.properties.in_.state)
								}
								raw_data["in"] = [$_yes__can_create_entry__yes.properties.in_.state.name, raw_in_];
							}
							raw_can_create_entry = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__entries_are_editable.properties.can_create_entry.state)
					}
					raw_data["can create entry"] = [$_yes__entries_are_editable.properties.can_create_entry.state.name, raw_can_create_entry];
				}
				{
					let raw_is_importing: Record<string, any>;
					switch ($_yes__entries_are_editable.properties.is_importing.state.name) {
						case 'no': {
							const $_no__is_importing = $_yes__entries_are_editable.properties.is_importing.state.node;
							const raw_data: Record<string, any> = {};
							raw_is_importing = raw_data
							break;
						}
						case 'yes': {
							const $_yes__is_importing = $_yes__entries_are_editable.properties.is_importing.state.node;
							const raw_data: Record<string, any> = {};
							raw_is_importing = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__entries_are_editable.properties.is_importing.state)
					}
					raw_data["is importing"] = [$_yes__entries_are_editable.properties.is_importing.state.name, raw_is_importing];
				}
				raw_entries_are_editable = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_query__client_state.properties.entries_are_editable.state)
		}
		raw_data["entries are editable"] = [$_query__client_state.properties.entries_are_editable.state.name, raw_entries_are_editable];
	}
	const raw_filters: Record<string, any> = {};
	for (let [k,v] of $_query__client_state.properties.filters) {
		const $_filters = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_active: Record<string, any>;
			switch ($_filters.properties.active.state.name) {
				case 'no': {
					const $_no__active = $_filters.properties.active.state.node;
					const raw_data: Record<string, any> = {};
					raw_active = raw_data
					break;
				}
				case 'yes': {
					const $_yes__active = $_filters.properties.active.state.node;
					const raw_data: Record<string, any> = {};
					raw_active = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_filters.properties.active.state)
			}
			raw_data["active"] = [$_filters.properties.active.state.name, raw_active];
		}
		raw_filters[k] = raw_data
	}
	raw_data["filters"] = raw_filters;
	{
		let raw_has_columns: Record<string, any>;
		switch ($_query__client_state.properties.has_columns.state.name) {
			case 'no': {
				const $_no__has_columns = $_query__client_state.properties.has_columns.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_columns = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_columns = $_query__client_state.properties.has_columns.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["first"] = $_yes__has_columns.properties.first.entry;
				raw_has_columns = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_query__client_state.properties.has_columns.state)
		}
		raw_data["has columns"] = [$_query__client_state.properties.has_columns.state.name, raw_has_columns];
	}
	{
		let raw_has_result: Record<string, any>;
		switch ($_query__client_state.properties.has_result.state.name) {
			case 'no': {
				const $_no__has_result = $_query__client_state.properties.has_result.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_result = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_result = $_query__client_state.properties.has_result.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["amount of entries visible"] = $_yes__has_result.properties.amount_of_entries_visible.value;
				{
					let raw_backend_updates_are_available: Record<string, any>;
					switch ($_yes__has_result.properties.backend_updates_are_available.state.name) {
						case 'no': {
							const $_no__backend_updates_are_available = $_yes__has_result.properties.backend_updates_are_available.state.node;
							const raw_data: Record<string, any> = {};
							raw_backend_updates_are_available = raw_data
							break;
						}
						case 'yes': {
							const $_yes__backend_updates_are_available = $_yes__has_result.properties.backend_updates_are_available.state.node;
							const raw_data: Record<string, any> = {};
							raw_backend_updates_are_available = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_result.properties.backend_updates_are_available.state)
					}
					raw_data["backend updates are available"] = [$_yes__has_result.properties.backend_updates_are_available.state.name, raw_backend_updates_are_available];
				}
				const raw_entries: Record<string, any> = {};
				for (let [k,v] of $_yes__has_result.properties.entries) {
					const $_entries__yes__has_result = v;
					const raw_data: Record<string, any> = {};
					const raw_cells: Record<string, any> = {};
					for (let [k,v] of $_entries__yes__has_result.properties.cells) {
						const $_cells = v;
						const raw_data: Record<string, any> = {};
						{
							let raw_column_type: Record<string, any>;
							switch ($_cells.properties.column_type.state.name) {
								case 'content': {
									const $_content__column_type__cells = $_cells.properties.column_type.state.node;
									const raw_data: Record<string, any> = {};
									raw_column_type = raw_data
									break;
								}
								case 'id': {
									const $_id__column_type__cells = $_cells.properties.column_type.state.node;
									const raw_data: Record<string, any> = {};
									raw_column_type = raw_data
									break;
								}
								default:
									throw new Error("unexpected state: " + $_cells.properties.column_type.state)
							}
							raw_data["column type"] = [$_cells.properties.column_type.state.name, raw_column_type];
						}
						{
							let raw_has_successor: Record<string, any>;
							switch ($_cells.properties.has_successor.state.name) {
								case 'no': {
									const $_no__has_successor__cells = $_cells.properties.has_successor.state.node;
									const raw_data: Record<string, any> = {};
									raw_has_successor = raw_data
									break;
								}
								case 'yes': {
									const $_yes__has_successor__cells = $_cells.properties.has_successor.state.node;
									const raw_data: Record<string, any> = {};
									raw_data["successor"] = $_yes__has_successor__cells.properties.successor.entry;
									raw_has_successor = raw_data
									break;
								}
								default:
									throw new Error("unexpected state: " + $_cells.properties.has_successor.state)
							}
							raw_data["has successor"] = [$_cells.properties.has_successor.state.name, raw_has_successor];
						}
						{
							let raw_type: Record<string, any>;
							switch ($_cells.properties.type.state.name) {
								case 'file': {
									const $_file__type__cells = $_cells.properties.type.state.node;
									const raw_data: Record<string, any> = {};
									{
										let raw_is_set: Record<string, any>;
										switch ($_file__type__cells.properties.is_set.state.name) {
											case 'no': {
												const $_no__is_set__file__type__cells = $_file__type__cells.properties.is_set.state.node;
												const raw_data: Record<string, any> = {};
												raw_is_set = raw_data
												break;
											}
											case 'yes': {
												const $_yes__is_set__file__type__cells = $_file__type__cells.properties.is_set.state.node;
												const raw_data: Record<string, any> = {};
												raw_data["extension"] = $_yes__is_set__file__type__cells.properties.extension;
												raw_data["token"] = $_yes__is_set__file__type__cells.properties.token;
												raw_is_set = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_file__type__cells.properties.is_set.state)
										}
										raw_data["is set"] = [$_file__type__cells.properties.is_set.state.name, raw_is_set];
									}
									raw_type = raw_data
									break;
								}
								case 'number': {
									const $_number__type__cells = $_cells.properties.type.state.node;
									const raw_data: Record<string, any> = {};
									{
										let raw_is_set: Record<string, any>;
										switch ($_number__type__cells.properties.is_set.state.name) {
											case 'no': {
												const $_no__is_set__number__type__cells = $_number__type__cells.properties.is_set.state.node;
												const raw_data: Record<string, any> = {};
												raw_is_set = raw_data
												break;
											}
											case 'yes': {
												const $_yes__is_set__number__type__cells = $_number__type__cells.properties.is_set.state.node;
												const raw_data: Record<string, any> = {};
												raw_data["number"] = $_yes__is_set__number__type__cells.properties.number.value;
												raw_data["textual representation"] = $_yes__is_set__number__type__cells.properties.textual_representation;
												raw_is_set = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_number__type__cells.properties.is_set.state)
										}
										raw_data["is set"] = [$_number__type__cells.properties.is_set.state.name, raw_is_set];
									}
									raw_data["numerical type properties"] = serialize_numerical_type_properties($_number__type__cells.properties.numerical_type_properties);
									raw_type = raw_data
									break;
								}
								case 'state group': {
									const $_state_group__type__cells = $_cells.properties.type.state.node;
									const raw_data: Record<string, any> = {};
									{
										let raw_is_set: Record<string, any>;
										switch ($_state_group__type__cells.properties.is_set.state.name) {
											case 'no': {
												const $_no__is_set__state_group__type__cells = $_state_group__type__cells.properties.is_set.state.node;
												const raw_data: Record<string, any> = {};
												raw_is_set = raw_data
												break;
											}
											case 'yes': {
												const $_yes__is_set__state_group__type__cells = $_state_group__type__cells.properties.is_set.state.node;
												const raw_data: Record<string, any> = {};
												raw_data["state"] = $_yes__is_set__state_group__type__cells.properties.state;
												raw_data["style"] = serialize_style($_yes__is_set__state_group__type__cells.properties.style);
												raw_is_set = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_state_group__type__cells.properties.is_set.state)
										}
										raw_data["is set"] = [$_state_group__type__cells.properties.is_set.state.name, raw_is_set];
									}
									const raw_states: Record<string, any> = {};
									for (let [k,v] of $_state_group__type__cells.properties.states) {
										const $_states__state_group__type__cells = v;
										const raw_data: Record<string, any> = {};
										{
											let raw_is_selected: Record<string, any>;
											switch ($_states__state_group__type__cells.properties.is_selected.state.name) {
												case 'no': {
													const $_no__is_selected__states__state_group__type__cells = $_states__state_group__type__cells.properties.is_selected.state.node;
													const raw_data: Record<string, any> = {};
													raw_is_selected = raw_data
													break;
												}
												case 'yes': {
													const $_yes__is_selected__states__state_group__type__cells = $_states__state_group__type__cells.properties.is_selected.state.node;
													const raw_data: Record<string, any> = {};
													raw_is_selected = raw_data
													break;
												}
												default:
													throw new Error("unexpected state: " + $_states__state_group__type__cells.properties.is_selected.state)
											}
											raw_data["is selected"] = [$_states__state_group__type__cells.properties.is_selected.state.name, raw_is_selected];
										}
										raw_states[k] = raw_data
									}
									raw_data["states"] = raw_states;
									raw_type = raw_data
									break;
								}
								case 'text': {
									const $_text__type__cells = $_cells.properties.type.state.node;
									const raw_data: Record<string, any> = {};
									{
										let raw_is_set: Record<string, any>;
										switch ($_text__type__cells.properties.is_set.state.name) {
											case 'no': {
												const $_no__is_set__text__type__cells = $_text__type__cells.properties.is_set.state.node;
												const raw_data: Record<string, any> = {};
												raw_is_set = raw_data
												break;
											}
											case 'yes': {
												const $_yes__is_set__text__type__cells = $_text__type__cells.properties.is_set.state.node;
												const raw_data: Record<string, any> = {};
												raw_data["text"] = $_yes__is_set__text__type__cells.properties.text;
												raw_is_set = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_text__type__cells.properties.is_set.state)
										}
										raw_data["is set"] = [$_text__type__cells.properties.is_set.state.name, raw_is_set];
									}
									raw_type = raw_data
									break;
								}
								case 'widget': {
									const $_widget__type__cells = $_cells.properties.type.state.node;
									const raw_data: Record<string, any> = {};
									raw_type = raw_data
									break;
								}
								default:
									throw new Error("unexpected state: " + $_cells.properties.type.state)
							}
							raw_data["type"] = [$_cells.properties.type.state.name, raw_type];
						}
						raw_cells[k] = raw_data
					}
					raw_data["cells"] = raw_cells;
					raw_data["entry status"] = serialize_query_entry_status($_entries__yes__has_result.properties.entry_status);
					{
						let raw_has_cells: Record<string, any>;
						switch ($_entries__yes__has_result.properties.has_cells.state.name) {
							case 'no': {
								const $_no__has_cells = $_entries__yes__has_result.properties.has_cells.state.node;
								const raw_data: Record<string, any> = {};
								raw_has_cells = raw_data
								break;
							}
							case 'yes': {
								const $_yes__has_cells = $_entries__yes__has_result.properties.has_cells.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["first"] = $_yes__has_cells.properties.first.entry;
								raw_has_cells = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_entries__yes__has_result.properties.has_cells.state)
						}
						raw_data["has cells"] = [$_entries__yes__has_result.properties.has_cells.state.name, raw_has_cells];
					}
					{
						let raw_is_editable: Record<string, any>;
						switch ($_entries__yes__has_result.properties.is_editable.state.name) {
							case 'no': {
								const $_no__is_editable__entries = $_entries__yes__has_result.properties.is_editable.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_editable = raw_data
								break;
							}
							case 'yes': {
								const $_yes__is_editable__entries = $_entries__yes__has_result.properties.is_editable.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_editable = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_entries__yes__has_result.properties.is_editable.state)
						}
						raw_data["is editable"] = [$_entries__yes__has_result.properties.is_editable.state.name, raw_is_editable];
					}
					{
						let raw_is_selected: Record<string, any>;
						switch ($_entries__yes__has_result.properties.is_selected.state.name) {
							case 'no': {
								const $_no__is_selected__entries = $_entries__yes__has_result.properties.is_selected.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_selected = raw_data
								break;
							}
							case 'yes': {
								const $_yes__is_selected__entries = $_entries__yes__has_result.properties.is_selected.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["selected entry"] = $_yes__is_selected__entries.properties.selected_entry.entry;
								raw_is_selected = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_entries__yes__has_result.properties.is_selected.state)
						}
						raw_data["is selected"] = [$_entries__yes__has_result.properties.is_selected.state.name, raw_is_selected];
					}
					{
						let raw_is_valid: Record<string, any>;
						switch ($_entries__yes__has_result.properties.is_valid.state.name) {
							case 'no': {
								const $_no__is_valid__entries = $_entries__yes__has_result.properties.is_valid.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_valid = raw_data
								break;
							}
							case 'yes': {
								const $_yes__is_valid__entries = $_entries__yes__has_result.properties.is_valid.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_valid = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_entries__yes__has_result.properties.is_valid.state)
						}
						raw_data["is valid"] = [$_entries__yes__has_result.properties.is_valid.state.name, raw_is_valid];
					}
					raw_data["style"] = serialize_style($_entries__yes__has_result.properties.style);
					{
						let raw_use_for: Record<string, any>;
						switch ($_entries__yes__has_result.properties.use_for.state.name) {
							case 'candidates': {
								const $_candidates__use_for__entries = $_entries__yes__has_result.properties.use_for.state.node;
								const raw_data: Record<string, any> = {};
								raw_use_for = raw_data
								break;
							}
							case 'query': {
								const $_query__use_for__entries = $_entries__yes__has_result.properties.use_for.state.node;
								const raw_data: Record<string, any> = {};
								raw_use_for = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_entries__yes__has_result.properties.use_for.state)
						}
						raw_data["use for"] = [$_entries__yes__has_result.properties.use_for.state.name, raw_use_for];
					}
					raw_entries[k] = raw_data
				}
				raw_data["entries"] = raw_entries;
				{
					let raw_has_more_entries_than_maximum: Record<string, any>;
					switch ($_yes__has_result.properties.has_more_entries_than_maximum.state.name) {
						case 'no': {
							const $_no__has_more_entries_than_maximum = $_yes__has_result.properties.has_more_entries_than_maximum.state.node;
							const raw_data: Record<string, any> = {};
							raw_has_more_entries_than_maximum = raw_data
							break;
						}
						case 'yes': {
							const $_yes__has_more_entries_than_maximum = $_yes__has_result.properties.has_more_entries_than_maximum.state.node;
							const raw_data: Record<string, any> = {};
							{
								let raw_can_show_all: Record<string, any>;
								switch ($_yes__has_more_entries_than_maximum.properties.can_show_all.state.name) {
									case 'no': {
										const $_no__can_show_all = $_yes__has_more_entries_than_maximum.properties.can_show_all.state.node;
										const raw_data: Record<string, any> = {};
										raw_can_show_all = raw_data
										break;
									}
									case 'yes': {
										const $_yes__can_show_all = $_yes__has_more_entries_than_maximum.properties.can_show_all.state.node;
										const raw_data: Record<string, any> = {};
										raw_can_show_all = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_yes__has_more_entries_than_maximum.properties.can_show_all.state)
								}
								raw_data["can show all"] = [$_yes__has_more_entries_than_maximum.properties.can_show_all.state.name, raw_can_show_all];
							}
							raw_has_more_entries_than_maximum = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_result.properties.has_more_entries_than_maximum.state)
					}
					raw_data["has more entries than maximum"] = [$_yes__has_result.properties.has_more_entries_than_maximum.state.name, raw_has_more_entries_than_maximum];
				}
				{
					let raw_is_empty: Record<string, any>;
					switch ($_yes__has_result.properties.is_empty.state.name) {
						case 'no': {
							const $_no__is_empty__yes__has_result = $_yes__has_result.properties.is_empty.state.node;
							const raw_data: Record<string, any> = {};
							{
								let raw_result_size: Record<string, any>;
								switch ($_no__is_empty__yes__has_result.properties.result_size.state.name) {
									case 'multiple': {
										const $_multiple__result_size = $_no__is_empty__yes__has_result.properties.result_size.state.node;
										const raw_data: Record<string, any> = {};
										raw_result_size = raw_data
										break;
									}
									case 'one': {
										const $_one = $_no__is_empty__yes__has_result.properties.result_size.state.node;
										const raw_data: Record<string, any> = {};
										raw_result_size = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_no__is_empty__yes__has_result.properties.result_size.state)
								}
								raw_data["result size"] = [$_no__is_empty__yes__has_result.properties.result_size.state.name, raw_result_size];
							}
							raw_is_empty = raw_data
							break;
						}
						case 'yes': {
							const $_yes__is_empty__yes__has_result = $_yes__has_result.properties.is_empty.state.node;
							const raw_data: Record<string, any> = {};
							raw_is_empty = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_result.properties.is_empty.state)
					}
					raw_data["is empty"] = [$_yes__has_result.properties.is_empty.state.name, raw_is_empty];
				}
				{
					let raw_selected_entries: Record<string, any>;
					switch ($_yes__has_result.properties.selected_entries.state.name) {
						case 'all': {
							const $_all = $_yes__has_result.properties.selected_entries.state.node;
							const raw_data: Record<string, any> = {};
							raw_selected_entries = raw_data
							break;
						}
						case 'none': {
							const $_none__selected_entries = $_yes__has_result.properties.selected_entries.state.node;
							const raw_data: Record<string, any> = {};
							raw_selected_entries = raw_data
							break;
						}
						case 'some': {
							const $_some = $_yes__has_result.properties.selected_entries.state.node;
							const raw_data: Record<string, any> = {};
							raw_selected_entries = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_result.properties.selected_entries.state)
					}
					raw_data["selected entries"] = [$_yes__has_result.properties.selected_entries.state.name, raw_selected_entries];
				}
				raw_data["total amount of entries"] = $_yes__has_result.properties.total_amount_of_entries.value;
				raw_has_result = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_query__client_state.properties.has_result.state)
		}
		raw_data["has result"] = [$_query__client_state.properties.has_result.state.name, raw_has_result];
	}
	{
		let raw_has_selected_entries: Record<string, any>;
		switch ($_query__client_state.properties.has_selected_entries.state.name) {
			case 'no': {
				const $_no__has_selected_entries = $_query__client_state.properties.has_selected_entries.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_selected_entries = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_selected_entries = $_query__client_state.properties.has_selected_entries.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["number of editable selected entries"] = $_yes__has_selected_entries.properties.number_of_editable_selected_entries.value;
				raw_data["number of selected entries"] = $_yes__has_selected_entries.properties.number_of_selected_entries.value;
				const raw_selected_entries: Record<string, any> = {};
				for (let [k,v] of $_yes__has_selected_entries.properties.selected_entries) {
					const $_selected_entries = v;
					const raw_data: Record<string, any> = {};
					raw_data["entry status"] = serialize_query_entry_status($_selected_entries.properties.entry_status);
					{
						let raw_is_editable: Record<string, any>;
						switch ($_selected_entries.properties.is_editable.state.name) {
							case 'no': {
								const $_no__is_editable__selected_entries = $_selected_entries.properties.is_editable.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_editable = raw_data
								break;
							}
							case 'yes': {
								const $_yes__is_editable__selected_entries = $_selected_entries.properties.is_editable.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_editable = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_selected_entries.properties.is_editable.state)
						}
						raw_data["is editable"] = [$_selected_entries.properties.is_editable.state.name, raw_is_editable];
					}
					raw_selected_entries[k] = raw_data
				}
				raw_data["selected entries"] = raw_selected_entries;
				raw_has_selected_entries = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_query__client_state.properties.has_selected_entries.state)
		}
		raw_data["has selected entries"] = [$_query__client_state.properties.has_selected_entries.state.name, raw_has_selected_entries];
	}
	{
		let raw_is_busy_querying: Record<string, any>;
		switch ($_query__client_state.properties.is_busy_querying.state.name) {
			case 'no': {
				const $_no__is_busy_querying = $_query__client_state.properties.is_busy_querying.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_request_status: Record<string, any>;
					switch ($_no__is_busy_querying.properties.request_status.state.name) {
						case 'failure': {
							const $_failure__request_status = $_no__is_busy_querying.properties.request_status.state.node;
							const raw_data: Record<string, any> = {};
							raw_request_status = raw_data
							break;
						}
						case 'success': {
							const $_success__request_status = $_no__is_busy_querying.properties.request_status.state.node;
							const raw_data: Record<string, any> = {};
							raw_request_status = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_no__is_busy_querying.properties.request_status.state)
					}
					raw_data["request status"] = [$_no__is_busy_querying.properties.request_status.state.name, raw_request_status];
				}
				raw_is_busy_querying = raw_data
				break;
			}
			case 'yes': {
				const $_yes__is_busy_querying = $_query__client_state.properties.is_busy_querying.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_requery_needed: Record<string, any>;
					switch ($_yes__is_busy_querying.properties.requery_needed.state.name) {
						case 'no': {
							const $_no__requery_needed = $_yes__is_busy_querying.properties.requery_needed.state.node;
							const raw_data: Record<string, any> = {};
							raw_requery_needed = raw_data
							break;
						}
						case 'yes': {
							const $_yes__requery_needed = $_yes__is_busy_querying.properties.requery_needed.state.node;
							const raw_data: Record<string, any> = {};
							raw_requery_needed = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__is_busy_querying.properties.requery_needed.state)
					}
					raw_data["requery needed"] = [$_yes__is_busy_querying.properties.requery_needed.state.name, raw_requery_needed];
				}
				raw_is_busy_querying = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_query__client_state.properties.is_busy_querying.state)
		}
		raw_data["is busy querying"] = [$_query__client_state.properties.is_busy_querying.state.name, raw_is_busy_querying];
	}
	{
		let raw_show_all: Record<string, any>;
		switch ($_query__client_state.properties.show_all.state.name) {
			case 'no': {
				const $_no__show_all = $_query__client_state.properties.show_all.state.node;
				const raw_data: Record<string, any> = {};
				raw_show_all = raw_data
				break;
			}
			case 'yes': {
				const $_yes__show_all = $_query__client_state.properties.show_all.state.node;
				const raw_data: Record<string, any> = {};
				raw_show_all = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_query__client_state.properties.show_all.state)
		}
		raw_data["show all"] = [$_query__client_state.properties.show_all.state.name, raw_show_all];
	}
	{
		let raw_use_for: Record<string, any>;
		switch ($_query__client_state.properties.use_for.state.name) {
			case 'candidates': {
				const $_candidates__use_for__query = $_query__client_state.properties.use_for.state.node;
				const raw_data: Record<string, any> = {};
				raw_use_for = raw_data
				break;
			}
			case 'query': {
				const $_query__use_for__query = $_query__client_state.properties.use_for.state.node;
				const raw_data: Record<string, any> = {};
				raw_use_for = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_query__client_state.properties.use_for.state)
		}
		raw_data["use for"] = [$_query__client_state.properties.use_for.state.name, raw_use_for];
	}
	raw_data["view definition"] = $_query__client_state.properties.view_definition.entry;
	raw_data["view definition context"] = $_query__client_state.properties.view_definition_context.entry;
	return raw_data;
}
function serialize_query_entry_status($_query_entry_status: read_api.Cquery_entry_status) {
	const raw_data: Record<string, any> = {};
	{
		let raw_initialized: Record<string, any>;
		switch ($_query_entry_status.properties.initialized.state.name) {
			case 'no': {
				const $_no__initialized__query_entry_status = $_query_entry_status.properties.initialized.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["referenced node"] = serialize_id_path($_no__initialized__query_entry_status.properties.referenced_node);
				raw_initialized = raw_data
				break;
			}
			case 'unknown': {
				const $_unknown__initialized = $_query_entry_status.properties.initialized.state.node;
				const raw_data: Record<string, any> = {};
				raw_initialized = raw_data
				break;
			}
			case 'yes': {
				const $_yes__initialized__query_entry_status = $_query_entry_status.properties.initialized.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["referenced node"] = serialize_client_id_path($_yes__initialized__query_entry_status.properties.referenced_node);
				raw_initialized = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_query_entry_status.properties.initialized.state)
		}
		raw_data["initialized"] = [$_query_entry_status.properties.initialized.state.name, raw_initialized];
	}
	return raw_data;
}
function serialize_report_parameters($_report_parameters: read_api.Creport_parameters) {
	const raw_data: Record<string, any> = {};
	{
		let raw_is_valid: Record<string, any>;
		switch ($_report_parameters.properties.is_valid.state.name) {
			case 'no': {
				const $_no__is_valid__report_parameters = $_report_parameters.properties.is_valid.state.node;
				const raw_data: Record<string, any> = {};
				raw_is_valid = raw_data
				break;
			}
			case 'yes': {
				const $_yes__is_valid__report_parameters = $_report_parameters.properties.is_valid.state.node;
				const raw_data: Record<string, any> = {};
				raw_is_valid = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_report_parameters.properties.is_valid.state)
		}
		raw_data["is valid"] = [$_report_parameters.properties.is_valid.state.name, raw_is_valid];
	}
	const raw_parameters: Record<string, any> = {};
	for (let [k,v] of $_report_parameters.properties.parameters) {
		const $_parameters = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_type: Record<string, any>;
			switch ($_parameters.properties.type.state.name) {
				case 'number': {
					const $_number__type__parameters = $_parameters.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_is_set: Record<string, any>;
						switch ($_number__type__parameters.properties.is_set.state.name) {
							case 'no': {
								const $_no__is_set__number__type__parameters = $_number__type__parameters.properties.is_set.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_set = raw_data
								break;
							}
							case 'yes': {
								const $_yes__is_set__number__type__parameters = $_number__type__parameters.properties.is_set.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["value"] = $_yes__is_set__number__type__parameters.properties.value.value;
								raw_is_set = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_number__type__parameters.properties.is_set.state)
						}
						raw_data["is set"] = [$_number__type__parameters.properties.is_set.state.name, raw_is_set];
					}
					{
						let raw_is_valid: Record<string, any>;
						switch ($_number__type__parameters.properties.is_valid.state.name) {
							case 'no': {
								const $_no__is_valid__number__type__parameters = $_number__type__parameters.properties.is_valid.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_valid = raw_data
								break;
							}
							case 'yes': {
								const $_yes__is_valid__number__type__parameters = $_number__type__parameters.properties.is_valid.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_valid = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_number__type__parameters.properties.is_valid.state)
						}
						raw_data["is valid"] = [$_number__type__parameters.properties.is_valid.state.name, raw_is_valid];
					}
					raw_data["numerical type properties"] = serialize_numerical_type_properties($_number__type__parameters.properties.numerical_type_properties);
					raw_type = raw_data
					break;
				}
				case 'text': {
					const $_text__type__parameters = $_parameters.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_is_set: Record<string, any>;
						switch ($_text__type__parameters.properties.is_set.state.name) {
							case 'no': {
								const $_no__is_set__text__type__parameters = $_text__type__parameters.properties.is_set.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_set = raw_data
								break;
							}
							case 'yes': {
								const $_yes__is_set__text__type__parameters = $_text__type__parameters.properties.is_set.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["value"] = $_yes__is_set__text__type__parameters.properties.value;
								raw_is_set = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_text__type__parameters.properties.is_set.state)
						}
						raw_data["is set"] = [$_text__type__parameters.properties.is_set.state.name, raw_is_set];
					}
					{
						let raw_is_valid: Record<string, any>;
						switch ($_text__type__parameters.properties.is_valid.state.name) {
							case 'no': {
								const $_no__is_valid__text__type__parameters = $_text__type__parameters.properties.is_valid.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_valid = raw_data
								break;
							}
							case 'yes': {
								const $_yes__is_valid__text__type__parameters = $_text__type__parameters.properties.is_valid.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_valid = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_text__type__parameters.properties.is_valid.state)
						}
						raw_data["is valid"] = [$_text__type__parameters.properties.is_valid.state.name, raw_is_valid];
					}
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_parameters.properties.type.state)
			}
			raw_data["type"] = [$_parameters.properties.type.state.name, raw_type];
		}
		raw_parameters[k] = raw_data
	}
	raw_data["parameters"] = raw_parameters;
	return raw_data;
}
function serialize_resolve_status($_resolve_status: read_api.Cresolve_status) {
	const raw_data: Record<string, any> = {};
	{
		let raw_status: Record<string, any>;
		switch ($_resolve_status.properties.status.state.name) {
			case 'failed to resolve': {
				const $_failed_to_resolve = $_resolve_status.properties.status.state.node;
				const raw_data: Record<string, any> = {};
				raw_status = raw_data
				break;
			}
			case 'is busy resolving': {
				const $_is_busy_resolving = $_resolve_status.properties.status.state.node;
				const raw_data: Record<string, any> = {};
				raw_status = raw_data
				break;
			}
			case 'resolved': {
				const $_resolved__status = $_resolve_status.properties.status.state.node;
				const raw_data: Record<string, any> = {};
				raw_status = raw_data
				break;
			}
			case 'unresolved': {
				const $_unresolved__status = $_resolve_status.properties.status.state.node;
				const raw_data: Record<string, any> = {};
				raw_status = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_resolve_status.properties.status.state)
		}
		raw_data["status"] = [$_resolve_status.properties.status.state.name, raw_status];
	}
	{
		let raw_validation_result: Record<string, any>;
		switch ($_resolve_status.properties.validation_result.state.name) {
			case 'failure': {
				const $_failure__validation_result__resolve_status = $_resolve_status.properties.validation_result.state.node;
				const raw_data: Record<string, any> = {};
				raw_validation_result = raw_data
				break;
			}
			case 'success': {
				const $_success__validation_result__resolve_status = $_resolve_status.properties.validation_result.state.node;
				const raw_data: Record<string, any> = {};
				raw_validation_result = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_resolve_status.properties.validation_result.state)
		}
		raw_data["validation result"] = [$_resolve_status.properties.validation_result.state.name, raw_validation_result];
	}
	return raw_data;
}
function serialize_style($_style: read_api.Cstyle) {
	const raw_data: Record<string, any> = {};
	{
		let raw_initialized: Record<string, any>;
		switch ($_style.properties.initialized.state.name) {
			case 'no': {
				const $_no__initialized__style = $_style.properties.initialized.state.node;
				const raw_data: Record<string, any> = {};
				raw_initialized = raw_data
				break;
			}
			case 'yes': {
				const $_yes__initialized__style = $_style.properties.initialized.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_has_style: Record<string, any>;
					switch ($_yes__initialized__style.properties.has_style.state.name) {
						case 'no': {
							const $_no__has_style = $_yes__initialized__style.properties.has_style.state.node;
							const raw_data: Record<string, any> = {};
							raw_has_style = raw_data
							break;
						}
						case 'yes': {
							const $_yes__has_style = $_yes__initialized__style.properties.has_style.state.node;
							const raw_data: Record<string, any> = {};
							{
								let raw_type: Record<string, any>;
								switch ($_yes__has_style.properties.type.state.name) {
									case 'color': {
										const $_color = $_yes__has_style.properties.type.state.node;
										const raw_data: Record<string, any> = {};
										raw_data["value"] = $_color.properties.value;
										raw_type = raw_data
										break;
									}
									case 'fixed': {
										const $_fixed = $_yes__has_style.properties.type.state.node;
										const raw_data: Record<string, any> = {};
										{
											let raw_style: Record<string, any>;
											switch ($_fixed.properties.style.state.name) {
												case 'accent': {
													const $_accent = $_fixed.properties.style.state.node;
													const raw_data: Record<string, any> = {};
													raw_style = raw_data
													break;
												}
												case 'background': {
													const $_background = $_fixed.properties.style.state.node;
													const raw_data: Record<string, any> = {};
													raw_style = raw_data
													break;
												}
												case 'brand': {
													const $_brand = $_fixed.properties.style.state.node;
													const raw_data: Record<string, any> = {};
													raw_style = raw_data
													break;
												}
												case 'error': {
													const $_error__style = $_fixed.properties.style.state.node;
													const raw_data: Record<string, any> = {};
													raw_style = raw_data
													break;
												}
												case 'foreground': {
													const $_foreground = $_fixed.properties.style.state.node;
													const raw_data: Record<string, any> = {};
													raw_style = raw_data
													break;
												}
												case 'link': {
													const $_link = $_fixed.properties.style.state.node;
													const raw_data: Record<string, any> = {};
													raw_style = raw_data
													break;
												}
												case 'success': {
													const $_success__style = $_fixed.properties.style.state.node;
													const raw_data: Record<string, any> = {};
													raw_style = raw_data
													break;
												}
												case 'warning': {
													const $_warning__style = $_fixed.properties.style.state.node;
													const raw_data: Record<string, any> = {};
													raw_style = raw_data
													break;
												}
												default:
													throw new Error("unexpected state: " + $_fixed.properties.style.state)
											}
											raw_data["style"] = [$_fixed.properties.style.state.name, raw_style];
										}
										raw_type = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_yes__has_style.properties.type.state)
								}
								raw_data["type"] = [$_yes__has_style.properties.type.state.name, raw_type];
							}
							raw_has_style = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__initialized__style.properties.has_style.state)
					}
					raw_data["has style"] = [$_yes__initialized__style.properties.has_style.state.name, raw_has_style];
				}
				raw_initialized = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_style.properties.initialized.state)
		}
		raw_data["initialized"] = [$_style.properties.initialized.state.name, raw_initialized];
	}
	return raw_data;
}
function serialize_where_rules($_where_rules: read_api.Cwhere_rules) {
	const raw_data: Record<string, any> = {};
	const raw_rules: Record<string, any> = {};
	for (let [k,v] of $_where_rules.properties.rules) {
		const $_rules = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_is_valid: Record<string, any>;
			switch ($_rules.properties.is_valid.state.name) {
				case 'no': {
					const $_no__is_valid__rules = $_rules.properties.is_valid.state.node;
					const raw_data: Record<string, any> = {};
					raw_is_valid = raw_data
					break;
				}
				case 'yes': {
					const $_yes__is_valid__rules = $_rules.properties.is_valid.state.node;
					const raw_data: Record<string, any> = {};
					raw_is_valid = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_rules.properties.is_valid.state)
			}
			raw_data["is valid"] = [$_rules.properties.is_valid.state.name, raw_is_valid];
		}
		raw_data["resolve status"] = serialize_resolve_status($_rules.properties.resolve_status);
		raw_rules[k] = raw_data
	}
	raw_data["rules"] = raw_rules;
	return raw_data;
}
export function serialize($_client_state: read_api.Cclient_state) {
	const raw_data: Record<string, any> = {};
	{
		let raw_alt_key_pressed: Record<string, any>;
		switch ($_client_state.properties.alt_key_pressed.state.name) {
			case 'no': {
				const $_no__alt_key_pressed = $_client_state.properties.alt_key_pressed.state.node;
				const raw_data: Record<string, any> = {};
				raw_alt_key_pressed = raw_data
				break;
			}
			case 'yes': {
				const $_yes__alt_key_pressed = $_client_state.properties.alt_key_pressed.state.node;
				const raw_data: Record<string, any> = {};
				raw_alt_key_pressed = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_state.properties.alt_key_pressed.state)
		}
		raw_data["alt key pressed"] = [$_client_state.properties.alt_key_pressed.state.name, raw_alt_key_pressed];
	}
	{
		let raw_browser_family: Record<string, any>;
		switch ($_client_state.properties.browser_family.state.name) {
			case 'Chromium': {
				const $_Chromium = $_client_state.properties.browser_family.state.node;
				const raw_data: Record<string, any> = {};
				raw_browser_family = raw_data
				break;
			}
			case 'Edge': {
				const $_Edge = $_client_state.properties.browser_family.state.node;
				const raw_data: Record<string, any> = {};
				raw_browser_family = raw_data
				break;
			}
			case 'Safari': {
				const $_Safari = $_client_state.properties.browser_family.state.node;
				const raw_data: Record<string, any> = {};
				raw_browser_family = raw_data
				break;
			}
			case 'undetermined': {
				const $_undetermined__browser_family = $_client_state.properties.browser_family.state.node;
				const raw_data: Record<string, any> = {};
				raw_browser_family = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_state.properties.browser_family.state)
		}
		raw_data["browser family"] = [$_client_state.properties.browser_family.state.name, raw_browser_family];
	}
	{
		let raw_ctrl_key_pressed: Record<string, any>;
		switch ($_client_state.properties.ctrl_key_pressed.state.name) {
			case 'no': {
				const $_no__ctrl_key_pressed = $_client_state.properties.ctrl_key_pressed.state.node;
				const raw_data: Record<string, any> = {};
				raw_ctrl_key_pressed = raw_data
				break;
			}
			case 'yes': {
				const $_yes__ctrl_key_pressed = $_client_state.properties.ctrl_key_pressed.state.node;
				const raw_data: Record<string, any> = {};
				raw_ctrl_key_pressed = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_state.properties.ctrl_key_pressed.state)
		}
		raw_data["ctrl key pressed"] = [$_client_state.properties.ctrl_key_pressed.state.name, raw_ctrl_key_pressed];
	}
	{
		let raw_has_landing_page: Record<string, any>;
		switch ($_client_state.properties.has_landing_page.state.name) {
			case 'no': {
				const $_no__has_landing_page = $_client_state.properties.has_landing_page.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_landing_page = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_landing_page = $_client_state.properties.has_landing_page.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_landing_page = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_state.properties.has_landing_page.state)
		}
		raw_data["has landing page"] = [$_client_state.properties.has_landing_page.state.name, raw_has_landing_page];
	}
	{
		let raw_is_editable: Record<string, any>;
		switch ($_client_state.properties.is_editable.state.name) {
			case 'no': {
				const $_no__is_editable__client_state = $_client_state.properties.is_editable.state.node;
				const raw_data: Record<string, any> = {};
				raw_is_editable = raw_data
				break;
			}
			case 'yes': {
				const $_yes__is_editable__client_state = $_client_state.properties.is_editable.state.node;
				const raw_data: Record<string, any> = {};
				raw_is_editable = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_state.properties.is_editable.state)
		}
		raw_data["is editable"] = [$_client_state.properties.is_editable.state.name, raw_is_editable];
	}
	const raw_languages: Record<string, any> = {};
	for (let [k,v] of $_client_state.properties.languages) {
		const $_languages = v;
		const raw_data: Record<string, any> = {};
		raw_data["label"] = $_languages.properties.label;
		raw_languages[k] = raw_data
	}
	raw_data["languages"] = raw_languages;
	raw_data["logo url"] = $_client_state.properties.logo_url;
	raw_data["logo-sideways url"] = $_client_state.properties.logo_sideways_url;
	const raw_messages: Record<string, any> = {};
	for (let [k,v] of $_client_state.properties.messages) {
		const $_messages = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_has_body: Record<string, any>;
			switch ($_messages.properties.has_body.state.name) {
				case 'no': {
					const $_no__has_body = $_messages.properties.has_body.state.node;
					const raw_data: Record<string, any> = {};
					raw_has_body = raw_data
					break;
				}
				case 'yes': {
					const $_yes__has_body = $_messages.properties.has_body.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["body"] = $_yes__has_body.properties.body;
					raw_has_body = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_messages.properties.has_body.state)
			}
			raw_data["has body"] = [$_messages.properties.has_body.state.name, raw_has_body];
		}
		raw_data["title"] = $_messages.properties.title;
		{
			let raw_type: Record<string, any>;
			switch ($_messages.properties.type.state.name) {
				case 'error': {
					const $_error__type = $_messages.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_type = raw_data
					break;
				}
				case 'success': {
					const $_success__type = $_messages.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_type = raw_data
					break;
				}
				case 'waiting': {
					const $_waiting = $_messages.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_type = raw_data
					break;
				}
				case 'warning': {
					const $_warning__type = $_messages.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_messages.properties.type.state)
			}
			raw_data["type"] = [$_messages.properties.type.state.name, raw_type];
		}
		raw_messages[k] = raw_data
	}
	raw_data["messages"] = raw_messages;
	{
		let raw_meta_key_pressed: Record<string, any>;
		switch ($_client_state.properties.meta_key_pressed.state.name) {
			case 'no': {
				const $_no__meta_key_pressed = $_client_state.properties.meta_key_pressed.state.node;
				const raw_data: Record<string, any> = {};
				raw_meta_key_pressed = raw_data
				break;
			}
			case 'yes': {
				const $_yes__meta_key_pressed = $_client_state.properties.meta_key_pressed.state.node;
				const raw_data: Record<string, any> = {};
				raw_meta_key_pressed = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_state.properties.meta_key_pressed.state)
		}
		raw_data["meta key pressed"] = [$_client_state.properties.meta_key_pressed.state.name, raw_meta_key_pressed];
	}
	const raw_modules: Record<string, any> = {};
	for (let [k,v] of $_client_state.properties.modules) {
		const $_modules = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_has_logo: Record<string, any>;
			switch ($_modules.properties.has_logo.state.name) {
				case 'no': {
					const $_no__has_logo = $_modules.properties.has_logo.state.node;
					const raw_data: Record<string, any> = {};
					raw_has_logo = raw_data
					break;
				}
				case 'yes': {
					const $_yes__has_logo = $_modules.properties.has_logo.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["url"] = $_yes__has_logo.properties.url;
					raw_has_logo = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_modules.properties.has_logo.state)
			}
			raw_data["has logo"] = [$_modules.properties.has_logo.state.name, raw_has_logo];
		}
		raw_data["name"] = $_modules.properties.name;
		raw_modules[k] = raw_data
	}
	raw_data["modules"] = raw_modules;
	{
		let raw_network_connection_status: Record<string, any>;
		switch ($_client_state.properties.network_connection_status.state.name) {
			case 'alive': {
				const $_alive__network_connection_status = $_client_state.properties.network_connection_status.state.node;
				const raw_data: Record<string, any> = {};
				raw_network_connection_status = raw_data
				break;
			}
			case 'dead': {
				const $_dead__network_connection_status = $_client_state.properties.network_connection_status.state.node;
				const raw_data: Record<string, any> = {};
				raw_network_connection_status = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_state.properties.network_connection_status.state)
		}
		raw_data["network connection status"] = [$_client_state.properties.network_connection_status.state.name, raw_network_connection_status];
	}
	{
		let raw_platform_family: Record<string, any>;
		switch ($_client_state.properties.platform_family.state.name) {
			case 'Android': {
				const $_Android = $_client_state.properties.platform_family.state.node;
				const raw_data: Record<string, any> = {};
				raw_platform_family = raw_data
				break;
			}
			case 'Linux': {
				const $_Linux = $_client_state.properties.platform_family.state.node;
				const raw_data: Record<string, any> = {};
				raw_platform_family = raw_data
				break;
			}
			case 'Windows': {
				const $_Windows = $_client_state.properties.platform_family.state.node;
				const raw_data: Record<string, any> = {};
				raw_platform_family = raw_data
				break;
			}
			case 'iOS': {
				const $_iOS = $_client_state.properties.platform_family.state.node;
				const raw_data: Record<string, any> = {};
				raw_platform_family = raw_data
				break;
			}
			case 'macOS': {
				const $_macOS = $_client_state.properties.platform_family.state.node;
				const raw_data: Record<string, any> = {};
				raw_platform_family = raw_data
				break;
			}
			case 'undetermined': {
				const $_undetermined__platform_family = $_client_state.properties.platform_family.state.node;
				const raw_data: Record<string, any> = {};
				raw_platform_family = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_state.properties.platform_family.state)
		}
		raw_data["platform family"] = [$_client_state.properties.platform_family.state.name, raw_platform_family];
	}
	const raw_report_types: Record<string, any> = {};
	for (let [k,v] of $_client_state.properties.report_types) {
		const $_report_types__client_state = v;
		const raw_data: Record<string, any> = {};
		raw_report_types[k] = raw_data
	}
	raw_data["report types"] = raw_report_types;
	const raw_reports: Record<string, any> = {};
	for (let [k,v] of $_client_state.properties.reports) {
		const $_reports = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_definition: Record<string, any>;
			switch ($_reports.properties.definition.state.name) {
				case 'known': {
					const $_known = $_reports.properties.definition.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["of type"] = $_known.properties.of_type.entry;
					raw_definition = raw_data
					break;
				}
				case 'unknown': {
					const $_unknown__definition = $_reports.properties.definition.state.node;
					const raw_data: Record<string, any> = {};
					raw_definition = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_reports.properties.definition.state)
			}
			raw_data["definition"] = [$_reports.properties.definition.state.name, raw_definition];
		}
		{
			let raw_permissions: Record<string, any>;
			switch ($_reports.properties.permissions.state.name) {
				case 'read only': {
					const $_read_only = $_reports.properties.permissions.state.node;
					const raw_data: Record<string, any> = {};
					raw_permissions = raw_data
					break;
				}
				case 'writable': {
					const $_writable = $_reports.properties.permissions.state.node;
					const raw_data: Record<string, any> = {};
					raw_permissions = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_reports.properties.permissions.state)
			}
			raw_data["permissions"] = [$_reports.properties.permissions.state.name, raw_permissions];
		}
		raw_reports[k] = raw_data
	}
	raw_data["reports"] = raw_reports;
	raw_data["root"] = serialize_node($_client_state.properties.root);
	raw_data["selected language"] = $_client_state.properties.selected_language.entry;
	{
		let raw_server_connection_status: Record<string, any>;
		switch ($_client_state.properties.server_connection_status.state.name) {
			case 'alive': {
				const $_alive__server_connection_status = $_client_state.properties.server_connection_status.state.node;
				const raw_data: Record<string, any> = {};
				raw_server_connection_status = raw_data
				break;
			}
			case 'dead': {
				const $_dead__server_connection_status = $_client_state.properties.server_connection_status.state.node;
				const raw_data: Record<string, any> = {};
				raw_server_connection_status = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_state.properties.server_connection_status.state)
		}
		raw_data["server connection status"] = [$_client_state.properties.server_connection_status.state.name, raw_server_connection_status];
	}
	let raw_session: Record<string, any>;
	{
		const $_session = $_client_state.properties.session;
		const raw_data: Record<string, any> = {};
		{
			let raw_status: Record<string, any>;
			switch ($_session.properties.status.state.name) {
				case 'authenticated': {
					const $_authenticated = $_session.properties.status.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_anonymous_session: Record<string, any>;
						switch ($_authenticated.properties.anonymous_session.state.name) {
							case 'no': {
								const $_no__anonymous_session = $_authenticated.properties.anonymous_session.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_user_found: Record<string, any>;
									switch ($_no__anonymous_session.properties.user_found.state.name) {
										case 'no': {
											const $_no__user_found = $_no__anonymous_session.properties.user_found.state.node;
											const raw_data: Record<string, any> = {};
											raw_user_found = raw_data
											break;
										}
										case 'yes': {
											const $_yes__user_found = $_no__anonymous_session.properties.user_found.state.node;
											const raw_data: Record<string, any> = {};
											raw_user_found = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_no__anonymous_session.properties.user_found.state)
									}
									raw_data["user found"] = [$_no__anonymous_session.properties.user_found.state.name, raw_user_found];
								}
								raw_data["username"] = $_no__anonymous_session.properties.username;
								raw_anonymous_session = raw_data
								break;
							}
							case 'yes': {
								const $_yes__anonymous_session = $_authenticated.properties.anonymous_session.state.node;
								const raw_data: Record<string, any> = {};
								raw_anonymous_session = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_authenticated.properties.anonymous_session.state)
						}
						raw_data["anonymous session"] = [$_authenticated.properties.anonymous_session.state.name, raw_anonymous_session];
					}
					raw_data["token"] = $_authenticated.properties.token;
					raw_status = raw_data
					break;
				}
				case 'not authenticated': {
					const $_not_authenticated = $_session.properties.status.state.node;
					const raw_data: Record<string, any> = {};
					raw_status = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_session.properties.status.state)
			}
			raw_data["status"] = [$_session.properties.status.state.name, raw_status];
		}
		raw_session = raw_data
	}
	raw_data["session"] = raw_session;
	{
		let raw_shift_key_pressed: Record<string, any>;
		switch ($_client_state.properties.shift_key_pressed.state.name) {
			case 'no': {
				const $_no__shift_key_pressed = $_client_state.properties.shift_key_pressed.state.node;
				const raw_data: Record<string, any> = {};
				raw_shift_key_pressed = raw_data
				break;
			}
			case 'yes': {
				const $_yes__shift_key_pressed = $_client_state.properties.shift_key_pressed.state.node;
				const raw_data: Record<string, any> = {};
				raw_shift_key_pressed = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_state.properties.shift_key_pressed.state)
		}
		raw_data["shift key pressed"] = [$_client_state.properties.shift_key_pressed.state.name, raw_shift_key_pressed];
	}
	{
		let raw_toggle_key_pressed: Record<string, any>;
		switch ($_client_state.properties.toggle_key_pressed.state.name) {
			case 'no': {
				const $_no__toggle_key_pressed = $_client_state.properties.toggle_key_pressed.state.node;
				const raw_data: Record<string, any> = {};
				raw_toggle_key_pressed = raw_data
				break;
			}
			case 'yes': {
				const $_yes__toggle_key_pressed = $_client_state.properties.toggle_key_pressed.state.node;
				const raw_data: Record<string, any> = {};
				raw_toggle_key_pressed = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_state.properties.toggle_key_pressed.state)
		}
		raw_data["toggle key pressed"] = [$_client_state.properties.toggle_key_pressed.state.name, raw_toggle_key_pressed];
	}
	raw_data["version"] = $_client_state.properties.version;
	const raw_windows: Record<string, any> = {};
	for (let [k,v] of $_client_state.properties.windows) {
		const $_windows = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_has_active_view: Record<string, any>;
			switch ($_windows.properties.has_active_view.state.name) {
				case 'no': {
					const $_no__has_active_view = $_windows.properties.has_active_view.state.node;
					const raw_data: Record<string, any> = {};
					raw_has_active_view = raw_data
					break;
				}
				case 'yes': {
					const $_yes__has_active_view = $_windows.properties.has_active_view.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["view"] = $_yes__has_active_view.properties.view.entry;
					raw_has_active_view = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_windows.properties.has_active_view.state)
			}
			raw_data["has active view"] = [$_windows.properties.has_active_view.state.name, raw_has_active_view];
		}
		const raw_open_views: Record<string, any> = {};
		for (let [k,v] of $_windows.properties.open_views) {
			const $_open_views = v;
			const raw_data: Record<string, any> = {};
			{
				let raw_action_active: Record<string, any>;
				switch ($_open_views.properties.action_active.state.name) {
					case 'no': {
						const $_no__action_active = $_open_views.properties.action_active.state.node;
						const raw_data: Record<string, any> = {};
						raw_action_active = raw_data
						break;
					}
					case 'yes': {
						const $_yes__action_active = $_open_views.properties.action_active.state.node;
						const raw_data: Record<string, any> = {};
						{
							let raw_can_finish_step: Record<string, any>;
							switch ($_yes__action_active.properties.can_finish_step.state.name) {
								case 'no': {
									const $_no__can_finish_step = $_yes__action_active.properties.can_finish_step.state.node;
									const raw_data: Record<string, any> = {};
									raw_can_finish_step = raw_data
									break;
								}
								case 'yes': {
									const $_yes__can_finish_step = $_yes__action_active.properties.can_finish_step.state.node;
									const raw_data: Record<string, any> = {};
									raw_can_finish_step = raw_data
									break;
								}
								default:
									throw new Error("unexpected state: " + $_yes__action_active.properties.can_finish_step.state)
							}
							raw_data["can finish step"] = [$_yes__action_active.properties.can_finish_step.state.name, raw_can_finish_step];
						}
						{
							let raw_last_step: Record<string, any>;
							switch ($_yes__action_active.properties.last_step.state.name) {
								case 'no': {
									const $_no__last_step = $_yes__action_active.properties.last_step.state.node;
									const raw_data: Record<string, any> = {};
									raw_last_step = raw_data
									break;
								}
								case 'yes': {
									const $_yes__last_step = $_yes__action_active.properties.last_step.state.node;
									const raw_data: Record<string, any> = {};
									raw_last_step = raw_data
									break;
								}
								default:
									throw new Error("unexpected state: " + $_yes__action_active.properties.last_step.state)
							}
							raw_data["last step"] = [$_yes__action_active.properties.last_step.state.name, raw_last_step];
						}
						raw_action_active = raw_data
						break;
					}
					default:
						throw new Error("unexpected state: " + $_open_views.properties.action_active.state)
				}
				raw_data["action active"] = [$_open_views.properties.action_active.state.name, raw_action_active];
			}
			{
				let raw_is_active_view: Record<string, any>;
				switch ($_open_views.properties.is_active_view.state.name) {
					case 'no': {
						const $_no__is_active_view = $_open_views.properties.is_active_view.state.node;
						const raw_data: Record<string, any> = {};
						raw_is_active_view = raw_data
						break;
					}
					case 'yes': {
						const $_yes__is_active_view = $_open_views.properties.is_active_view.state.node;
						const raw_data: Record<string, any> = {};
						raw_is_active_view = raw_data
						break;
					}
					default:
						throw new Error("unexpected state: " + $_open_views.properties.is_active_view.state)
				}
				raw_data["is active view"] = [$_open_views.properties.is_active_view.state.name, raw_is_active_view];
			}
			{
				let raw_is_entry_view: Record<string, any>;
				switch ($_open_views.properties.is_entry_view.state.name) {
					case 'no': {
						const $_no__is_entry_view = $_open_views.properties.is_entry_view.state.node;
						const raw_data: Record<string, any> = {};
						raw_data["title"] = $_no__is_entry_view.properties.title;
						raw_is_entry_view = raw_data
						break;
					}
					case 'yes': {
						const $_yes__is_entry_view = $_open_views.properties.is_entry_view.state.node;
						const raw_data: Record<string, any> = {};
						raw_data["entry key"] = $_yes__is_entry_view.properties.entry_key;
						raw_data["entry path"] = $_yes__is_entry_view.properties.entry_path;
						raw_is_entry_view = raw_data
						break;
					}
					default:
						throw new Error("unexpected state: " + $_open_views.properties.is_entry_view.state)
				}
				raw_data["is entry view"] = [$_open_views.properties.is_entry_view.state.name, raw_is_entry_view];
			}
			{
				let raw_subscribe: Record<string, any>;
				switch ($_open_views.properties.subscribe.state.name) {
					case 'no': {
						const $_no__subscribe = $_open_views.properties.subscribe.state.node;
						const raw_data: Record<string, any> = {};
						raw_subscribe = raw_data
						break;
					}
					case 'yes': {
						const $_yes__subscribe = $_open_views.properties.subscribe.state.node;
						const raw_data: Record<string, any> = {};
						raw_subscribe = raw_data
						break;
					}
					default:
						throw new Error("unexpected state: " + $_open_views.properties.subscribe.state)
				}
				raw_data["subscribe"] = [$_open_views.properties.subscribe.state.name, raw_subscribe];
			}
			raw_data["view context"] = serialize_client_id_path($_open_views.properties.view_context);
			raw_data["view definition"] = $_open_views.properties.view_definition.entry;
			raw_data["view definition context"] = $_open_views.properties.view_definition_context.entry;
			raw_open_views[k] = raw_data
		}
		raw_data["open views"] = raw_open_views;
		raw_windows[k] = raw_data
	}
	raw_data["windows"] = raw_windows;
	return raw_data;
}